import React, { useEffect, useState } from "react";
import Header from "components/Headers/Header";
import {
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	CardFooter,
	Container,
	Row,
	Button,
	Table,
	Media,
	Badge,
	Pagination,
	PaginationItem,
	PaginationLink,
	Modal,
	Form,
	Col,
	Label,
	FormGroup,
    FormFeedback, 
	Input,
	ModalHeader,
	ModalFooter,
	ModalBody,
	InputGroupAddon,
	InputGroupText,
	InputGroup,
	CustomInput,
	Alert,
	Spinner,
	Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import {
  fetchAllUsers,
  fetchUserDetails,
  updateUserDetails,
  updateUserDetailsReset,
  updateMultiUsers,
  updateMultiUsersReset,
  adminCreateUser,
  adminCreateUserReset,
} from "redux/ManageUsers/ManageUsersAction";
import {fetchUniversities}  from "redux/Users/UsersActions";
import { fetchCoaches } from "redux/ScheduleTutor/ScheduleTutorActions";
import { customDropdown } from "util/reactCustomStyles";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { getUserData } from "redux/UserAuthentication/LoginActions";
import ReactDatetime from "react-datetime";
import { customDropdownWithBorder } from "util/reactCustomStyles";
import { app, db } from "../../firebase";
import {
  collection,
  getDocs,
  getDoc,
  query,
  where,
  onSnapshot,
  doc,
} from "firebase/firestore";
// import DataTable from "react-data-table-component"; // Replaced with Reactstrap Table
import moment from "moment-timezone";
import {fetchAppHourUsedLogs,fetchPremiumHourLogs,sendEmailApplicationHourUsed} from "redux/Logs/LogsAction";
import Logs from "components/Logs/Logs";
import StudentFreeHourLogs from "components/Logs/StudentFreeHourLogs";
import UserLogHistory from "components/Logs/UserLogHistory";
import StudentPremiumHourLogs from "components/Logs/StudentPremiumHourLogs";
import classnames from "classnames";
import useCustomPmrPrograms from "util/useCustomPmrPrograms";
import axios from "axios";
import AdminUserSubscription from "components/ManageUsers/AdminUserSubscription";
import ExcelJS from "exceljs";
import { getSpecialtyFields, getPlanById } from "config/subscriptionPlans";
import { getSpecialty } from "config/specialtyConfig";

const PLAN_ID_MAP = {
	'pmrPrep1Month49': '1 Month',
	'pmrPrep3Months85': '3 Months',
	'pmrPrep6Months119': '6 Months',
	'pmrPrep12Months149': '12 Months',
	'pmrPrep18Months189': '18 Months',
	'pmrPrep24Months229': '24 Months',
	'pmrPrep36Months279': '36 Months',
	'pmrPrep48Months339': '48 Months',
	'pmrPrep6Months85': '6 Months (Legacy)',
	'pmrPrep12Months160': '12 Months (Legacy)',
	'pmrPrep18Months235': '18 Months (Legacy)',
	'pmrPrep30Months300': '30 Months (Legacy)',
	'pmrPrep36Months349': '36 Months (Legacy)',
};

const getUserPlan = (user, fields) => {
	if (user[fields.lifetimeAccess] === true || user[fields.lifetimeAccess] === "true") return "Lifetime";
	if (user[fields.ultimateAdvisingStudent] === true || user[fields.ultimateAdvisingStudent] === "true") return "UAS";
	const pid = user[fields.planId];
	if (pid) {
		const plan = getPlanById(pid);
		if (plan) return `${plan.months} Month${plan.months !== 1 ? 's' : ''}`;
		return PLAN_ID_MAP[pid] || pid;
	}
	if (user[fields.trialStartDate]) return "Trial";
	return "-";
};

const getUserStatus = (user, fields) => {
	if (user[fields.lifetimeAccess] === true || user[fields.lifetimeAccess] === "true") {
		return { label: "Active", color: "success" };
	}
	if (user[fields.ultimateAdvisingStudent] === true || user[fields.ultimateAdvisingStudent] === "true") {
		return { label: "Active", color: "success" };
	}
	if (user[fields.subscriptionEndDate]) {
		const endDate = new Date(user[fields.subscriptionEndDate]);
		const now = new Date();
		const isActive = now < endDate;
		const daysRemaining = Math.ceil((endDate - now) / (1000 * 60 * 60 * 24));
		if (isActive) {
			return { label: `${daysRemaining} days`, color: daysRemaining <= 30 ? "warning" : "info", daysRemaining };
		}
		return { label: "Expired", color: "danger" };
	}
	if (user[fields.trialStartDate]) {
		const trialStart = new Date(user[fields.trialStartDate]);
		const trialEnd = new Date(trialStart);
		trialEnd.setDate(trialEnd.getDate() + 14);
		const now = new Date();
		const isActive = now < trialEnd;
		const daysRemaining = Math.ceil((trialEnd - now) / (1000 * 60 * 60 * 24));
		if (isActive) {
			return { label: `${daysRemaining} days`, color: "primary", daysRemaining };
		}
		return { label: "Expired", color: "danger" };
	}
	return { label: "No Access", color: "secondary" };
};

const getUserExpires = (user, fields) => {
	if (user[fields.lifetimeAccess] === true || user[fields.lifetimeAccess] === "true") return "Never";
	if (user[fields.ultimateAdvisingStudent] === true || user[fields.ultimateAdvisingStudent] === "true") return "Never";
	if (user[fields.subscriptionEndDate]) return moment(user[fields.subscriptionEndDate]).utcOffset(0, false).format('ll');
	if (user[fields.trialStartDate]) {
		const trialEnd = new Date(user[fields.trialStartDate]);
		trialEnd.setDate(trialEnd.getDate() + 14);
		return moment(trialEnd.toISOString()).utcOffset(0, false).format('ll');
	}
	return "-";
};

const getStatusCategory = (user, fields) => {
	const status = getUserStatus(user, fields);
	if (status.label === "Active") return "Active";
	if (status.label === "Expired") return "Expired";
	if (status.label === "No Access") return "No Access";
	// Has days remaining
	if (status.daysRemaining !== undefined && status.daysRemaining <= 30) return "Expiring Soon";
	return "Active";
};

const PLAN_RANK = { "Lifetime": 0, "UAS": 1, "48 Months": 2, "36 Months": 3, "30 Months (Legacy)": 3.5, "24 Months": 4, "18 Months": 5, "12 Months": 6, "6 Months": 7, "3 Months": 8, "1 Month": 9, "Trial": 10 };
const STATUS_RANK = { "Active": 0, "Expiring Soon": 1, "Expired": 2, "No Access": 3 };

const getPlanRank = (user, fields) => {
	const plan = getUserPlan(user, fields);
	if (plan in PLAN_RANK) return PLAN_RANK[plan];
	if (plan.includes("Legacy")) {
		const base = plan.replace(" (Legacy)", "");
		return (PLAN_RANK[base] ?? 5) + 0.5;
	}
	return plan === "-" ? 11 : 5;
};

const getStatusRank = (user, fields) => {
	return STATUS_RANK[getStatusCategory(user, fields)] ?? 3;
};

const getExpiresDate = (user, fields) => {
	if (user[fields.lifetimeAccess] === true || user[fields.lifetimeAccess] === "true") return Infinity;
	if (user[fields.ultimateAdvisingStudent] === true || user[fields.ultimateAdvisingStudent] === "true") return Infinity;
	if (user[fields.subscriptionEndDate]) return new Date(user[fields.subscriptionEndDate]).getTime();
	if (user[fields.trialStartDate]) {
		const trialEnd = new Date(user[fields.trialStartDate]);
		trialEnd.setDate(trialEnd.getDate() + 14);
		return trialEnd.getTime();
	}
	return -Infinity;
};



const ManageUsers = (props) => {
  	const dispatch = useDispatch();
	const specFields = getSpecialtyFields(props.activeSpecialty);

  	// const [allUsers, setData] = useState([]);
  	const [allUsers2, setData2] = useState([]);

	const [loading, setLoading] = useState(true);
	const [userDetailsLoading, setUserDetailsLoading] = useState();
	const [search, setSearch] = useState("");
  	const [data, setData] = useState([]);
  	const [filter, setFilter] = useState([]);

	// Pagination
	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 10;

	// Filters
	const [planFilter, setPlanFilter] = useState("");
	const [statusFilter, setStatusFilter] = useState("");
	const [yearFilter, setYearFilter] = useState("");
	const [programFilter, setProgramFilter] = useState("");

	// Sorting
	const [sortField, setSortField] = useState("name");
	const [sortDirection, setSortDirection] = useState("asc");

	// Year promotion
	const [promoModalOpen, setPromoModalOpen] = useState(false);
	const [promoLoading, setPromoLoading] = useState(false);
	const [promoResult, setPromoResult] = useState(null);
	const [promoLogs, setPromoLogs] = useState([]);
	const [promoLogsLoading, setPromoLogsLoading] = useState(false);
	const [promoLogPage, setPromoLogPage] = useState(1);
	const [expandedLogId, setExpandedLogId] = useState(null);
	const [promoDetailPage, setPromoDetailPage] = useState(1);
	const promoLogsPerPage = 5;
	const promoDetailsPerPage = 10;

	const [checkUsers, setCheckUsers] = useState([]);
	const [school, setSchool] = useState('');
	const [universities, setUniversities] = useState([])
	const [medicalSchools, setMedicalSchools] = useState([])

	const subscriptionFilter = [
		{ value: "", label: "ALL" },
		{ value: "Lifetime Access", label: "Lifetime Access" },
		{ value: "Active Subscription", label: "Active Subscription" },
		{ value: "In Trial", label: "In Trial" },
		{ value: "Expired", label: "Expired" },
		{ value: "No Access", label: "No Access" },
	];

	// Old subscription filter options (hidden)
	// const subscriptionFilterOld = [
	// 	{ value: "", label: "ALL" },
	// 	{ value: "Free Account", label: "Free Account" },
	// 	{ value: "PRO Member", label: "PRO Member" },
	// 	{ value: "Ultimate Advising Student", label: "Ultimate Advising Student" },
	// ];

	const [selectedHour, setSelectedHour] = useState("");
    const [selectedUser, setSelectedUser] = useState("");
    const [psValue, setPsValue] = useState(0)
    const [actValue, setActValue] = useState(0)
    const [miValue, setMiValue] = useState(0)
    const [secValue, setSecValue] = useState(0)
    const [generalValue, setGeneralValue] = useState(0)
    const [totalHour, setTotalHour] = useState(0)

	useEffect(() => {
		register("name");
		register("email");

		// PMR Prep fields
		register("year");
		register("pmrProgram");
		register("phoneNumber");

		register("homeAddress");
		register("selectedCountry");
		register("selectedCity");
		register("selectedState");
		register("postalCode");

		register("ultimateAdvisingStudent");
		register("lifetimeAccess");
		register("subscriptionEndDate");

		// Legacy fields (kept for compatibility)
		register("mcatDate");
		register("tutorHours");
		register("inputUworld");
		register("inputAamc");
		register("tpcEntryDate");
		register("schoolYear");
		register("university");
		register("shadowGoal");
		register("clinicalGoal");
		register("volunteerGoal");
		register("coach");
		register("proMemberStudent");
		register("assignedCoach");
		register("matriculated");

		// dispatch(
		// fetchAllUsers({
		// 	route: "",
		// 	order: order,
		// 	by: by,
		// 	searchFullName: searchFullName,
		// 	subscriptionFilter: subscription,
		// })
		// );
	}, []);

	useEffect(() => {
		if (props.fetchAllUsers.loading) {
			Swal.fire({
				allowOutsideClick: false,
				didOpen: () => {
				Swal.showLoading();
				},
			});
		} else {
			
			if (props.fetchAllUsers.allusers.length) {
				setData(props.fetchAllUsers.allusers);
				setFilter(props.fetchAllUsers.allusers);	
			}else{
				setData([]);
				setFilter([]);	
			}
			Swal.close();
			setLoading(false)
		}
	}, [props.fetchAllUsers]);

  	// useEffect(() => {
	// 	if(filter.length){
	// 		Swal.close();
	// 		setLoading(false)
	// 	}
  	// }, [filter]);

	const {
		register,
		getValues,
		unregister,
		watch,
		handleSubmit,
		setValue,
		formState: { errors },
	} = useForm();

	// useEffect(() => {
	// 	const fetchAllUsers = async () => {
	// 	const querySnapshot = await getDocs(collection(db, "users"));
	// 	let users = [];
	// 	querySnapshot.forEach((doc) => {
	// 		let v = doc.data();
	// 		users.push({
	// 		value: v.handle,
	// 		label: v.name,
	// 		image: typeof v.profilePicture != "undefined" ? v.profilePicture : "",
	// 		});
	// 	});
	// 	users.unshift({ value: "", label: "Select Users" });
	// 	setCheckUsers(users);
	// 	};
	// 	fetchAllUsers();
	// }, []);

	const [modalUpdateUser, setModalUpdateUser] = useState(false);
	const [modalUpdateMultiUsers, setModalUpdateMultiUsers] = useState(false);
	const [selectedUsers, setselectedUsers] = useState([]);

	// Extend Subscription modal state
	const [extendModal, setExtendModal] = useState(false);
	const [extendUser, setExtendUser] = useState(null);
	const [extendOption, setExtendOption] = useState("boards");
	const [customDate, setCustomDate] = useState("");
	const [extendLoading, setExtendLoading] = useState(false);

	// Create User modal state
	const [modalCreateUser, setModalCreateUser] = useState(false);
	const [createUserForm, setCreateUserForm] = useState({
		firstName: "",
		lastName: "",
		email: "",
		password: "",
		confirmPassword: "",
		phoneNumber: "",
		year: "",
		pmrProgram: "",
	});
	const [createUserErrors, setCreateUserErrors] = useState({});
	const [sendWelcomeEmail, setSendWelcomeEmail] = useState(true);
	const pmrProgramOptions = useCustomPmrPrograms();

	const yearOptions = [
		{ value: "Fellow", label: "Fellow" },
		{ value: "PGY 1", label: "PGY 1" },
		{ value: "PGY 2", label: "PGY 2" },
		{ value: "PGY 3", label: "PGY 3" },
		{ value: "PGY 4", label: "PGY 4" },
	];

	const openPromoModal = async () => {
		setPromoModalOpen(true);
		setPromoResult(null);
		setPromoLogsLoading(true);
		try {
			const res = await axios.post('/fetchYearPromotionLogs');
			setPromoLogs(res.data.logs || []);
		} catch {
			setPromoLogs([]);
		} finally {
			setPromoLogsLoading(false);
		}
	};

	const handleRunPromotion = async () => {
		const confirm = await Swal.fire({
			title: 'Run Year Promotion?',
			html: 'This will advance all users to the next PGY year.<br/><b>PGY 1→2, PGY 2→3, PGY 3→4, PGY 4→Fellow</b><br/><br/>This cannot be undone.',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, promote all',
			cancelButtonText: 'Cancel',
		});
		if (!confirm.isConfirmed) return;

		setPromoLoading(true);
		try {
			const res = await axios.post('/triggerYearPromotion');
			setPromoResult(res.data);
			if (res.data.skipped) {
				Swal.fire('Already Done', res.data.message, 'info');
			} else {
				Swal.fire('Success', `Promoted ${res.data.totalPromoted} users.`, 'success');
				// Refresh user list
				dispatch(fetchAllUsers());
			}
			// Refresh logs
			const logsRes = await axios.post('/fetchYearPromotionLogs');
			setPromoLogs(logsRes.data.logs || []);
		} catch (err) {
			Swal.fire('Error', err.response?.data?.error || 'Promotion failed', 'error');
		} finally {
			setPromoLoading(false);
		}
	};

	const toggleCreateUser = () => {
		setModalCreateUser(!modalCreateUser);
		if (modalCreateUser) {
			setCreateUserForm({
				firstName: "",
				lastName: "",
				email: "",
				password: "",
				confirmPassword: "",
				phoneNumber: "",
				year: "",
				pmrProgram: "",
			});
			setCreateUserErrors({});
		}
	};

	const formatPhoneDisplay = (v = "") => {
		let d = v.replace(/\D/g, "");
		if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
		if (d.length === 0) return "";
		if (d.length < 4) return d;
		if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
		return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6, 10)}`;
	};

	const toE164 = (formatted) => {
		const digits = formatted.replace(/\D/g, "");
		return digits.length === 10 ? `+1${digits}` : null;
	};

	const handleCreateUserChange = (field, value) => {
		if (field === "phoneNumber") {
			value = formatPhoneDisplay(value);
		}
		setCreateUserForm((prev) => ({ ...prev, [field]: value }));
		if (createUserErrors[field]) {
			setCreateUserErrors((prev) => ({ ...prev, [field]: "" }));
		}
	};

	const generatePassword = () => {
		const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
		const lower = "abcdefghijklmnopqrstuvwxyz";
		const digits = "0123456789";
		const special = "!@#$%^&*";
		const all = upper + lower + digits + special;
		// Guarantee at least one of each required type
		let pw = [
			upper[Math.floor(Math.random() * upper.length)],
			lower[Math.floor(Math.random() * lower.length)],
			digits[Math.floor(Math.random() * digits.length)],
			special[Math.floor(Math.random() * special.length)],
		];
		for (let i = pw.length; i < 12; i++) {
			pw.push(all[Math.floor(Math.random() * all.length)]);
		}
		// Shuffle
		for (let i = pw.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[pw[i], pw[j]] = [pw[j], pw[i]];
		}
		const generated = pw.join("");
		setCreateUserForm((prev) => ({ ...prev, password: generated, confirmPassword: generated }));
		setCreateUserErrors((prev) => ({ ...prev, password: "", confirmPassword: "" }));
	};

	const validateCreateUserForm = () => {
		const errs = {};
		if (!createUserForm.firstName.trim()) errs.firstName = "First name is required";
		if (!createUserForm.lastName.trim()) errs.lastName = "Last name is required";
		if (!createUserForm.email.trim()) errs.email = "Email is required";
		if (!createUserForm.password) errs.password = "Password is required";
		else if (createUserForm.password.length < 8) errs.password = "Must be at least 8 characters";
		else if (!/[a-zA-Z]/.test(createUserForm.password)) errs.password = "Must contain a letter";
		else if (!/[0-9]/.test(createUserForm.password)) errs.password = "Must contain a number";
		else if (!/[!@#$%^&*(),.?":{}|<>]/.test(createUserForm.password)) errs.password = "Must contain a special character";
		if (createUserForm.password !== createUserForm.confirmPassword) errs.confirmPassword = "Passwords must match";
		setCreateUserErrors(errs);
		return Object.keys(errs).length === 0;
	};

	const handleCreateUserSubmit = (e) => {
		e.preventDefault();
		if (!validateCreateUserForm()) return;

		const phoneE164 = createUserForm.phoneNumber ? toE164(createUserForm.phoneNumber) : "";
		dispatch(
			adminCreateUser({
				firstName: createUserForm.firstName.trim(),
				lastName: createUserForm.lastName.trim(),
				email: createUserForm.email.trim(),
				password: createUserForm.password,
				confirmPassword: createUserForm.confirmPassword,
				phoneNumber: phoneE164 || createUserForm.phoneNumber.replace(/\D/g, ""),
				[specFields.year]: createUserForm.year,
				[specFields.pmrProgram]: createUserForm.pmrProgram,
				specialty: props.activeSpecialty,
				sendWelcomeEmail,
			})
		);
	};

	useEffect(() => {
		if (props.adminCreateUser.loading) {
			Swal.fire({
				allowOutsideClick: false,
				title: "Creating account...",
				didOpen: () => {
					Swal.showLoading();
				},
			});
		} else if (props.adminCreateUser.success) {
			Swal.fire({
				title: "Success!",
				text: "User account created successfully!",
				icon: "success",
				timer: 3000,
			}).then(() => {
				setModalCreateUser(false);
				setCreateUserForm({
					firstName: "",
					lastName: "",
					email: "",
					password: "",
					confirmPassword: "",
					phoneNumber: "",
					year: "",
					pmrProgram: "",
				});
				setCreateUserErrors({});
				setSendWelcomeEmail(true);
				dispatch(adminCreateUserReset());
				dispatch(
					fetchAllUsers({
						route: "",
						subscriptionFilter: subscription,
					})
				);
			});
		} else if (props.adminCreateUser.error) {
			Swal.fire({
				title: "Error",
				text: props.adminCreateUser.error,
				icon: "error",
			});
			dispatch(adminCreateUserReset());
		}
	}, [props.adminCreateUser]);

	const selectUsers = (e) => {
		const values = [...e].map((opt) => opt.value);
		setselectedUsers(values);
		setValue("selectUsers", values);
	};

	useEffect(() => {
		if(props.fetchUserDetails.loading){
			setUserDetailsLoading(true)
		}else{
			setUserDetailsLoading(!userDetailsLoading)
			if (props.fetchUserDetails.userdetails.length) {
				
				

				setSelectedUser(props.fetchUserDetails.userdetails[0])
				calculateTotalHours(props.fetchUserDetails.userdetails[0])
				setValue("name", props.fetchUserDetails.userdetails[0].name);

				setValue("email", props.fetchUserDetails.userdetails[0].email);

				// Year and PM&R Program
				setValue(
					"year",
					typeof props.fetchUserDetails.userdetails[0][specFields.year] != "undefined"
					? props.fetchUserDetails.userdetails[0][specFields.year]
					: ""
				);
				setValue(
					"pmrProgram",
					typeof props.fetchUserDetails.userdetails[0][specFields.pmrProgram] != "undefined"
					? props.fetchUserDetails.userdetails[0][specFields.pmrProgram]
					: ""
				);

				// Phone Number
				setValue(
					"phoneNumber",
					typeof props.fetchUserDetails.userdetails[0].phoneNumber != "undefined"
					? props.fetchUserDetails.userdetails[0].phoneNumber
					: ""
				);

				setValue(
					"homeAddress",
					typeof props.fetchUserDetails.userdetails[0].homeAddress != "undefined"
					? props.fetchUserDetails.userdetails[0].homeAddress
					: ""
				);

				setValue(
					"tpcEntryDate",
					props.fetchUserDetails.userdetails[0].tpcEntryDate
				);
				setValue("mcatDate", props.fetchUserDetails.userdetails[0].mcatDate);
				setValue(
					"schoolYear",
					typeof props.fetchUserDetails.userdetails[0].schoolYear != "undefined"
					? props.fetchUserDetails.userdetails[0].schoolYear
					: ""
				);
				setValue(
					"university",
					typeof props.fetchUserDetails.userdetails[0].university != "undefined"
					? props.fetchUserDetails.userdetails[0].university
					: ""
				);

				setValue(
					"selectedCountry",
					typeof props.fetchUserDetails.userdetails[0].selectedCountry !=
					"undefined"
					? props.fetchUserDetails.userdetails[0].selectedCountry
					: ""
				);
				setValue(
					"selectedCity",
					typeof props.fetchUserDetails.userdetails[0].selectedCity != "undefined"
					? props.fetchUserDetails.userdetails[0].selectedCity
					: ""
				);
				setValue(
					"selectedState",
					typeof props.fetchUserDetails.userdetails[0].selectedState !=
					"undefined"
					? props.fetchUserDetails.userdetails[0].selectedState
					: ""
				);
				setValue(
					"postalCode",
					typeof props.fetchUserDetails.userdetails[0].postalCode != "undefined"
					? props.fetchUserDetails.userdetails[0].postalCode
					: ""
				);
				setValue("tutorHours", props.fetchUserDetails.userdetails[0].tutorHours);
				setValue("shadowGoal", props.fetchUserDetails.userdetails[0].shadowGoal);
				setValue(
					"clinicalGoal",
					props.fetchUserDetails.userdetails[0].clinicalGoal
				);
				setValue(
					"volunteerGoal",
					typeof props.fetchUserDetails.userdetails[0].volunteerGoal !=
					"undefined"
					? props.fetchUserDetails.userdetails[0].volunteerGoal
					: 0
				);

				setValue("mcatDate", props.fetchUserDetails.userdetails[0].mcatDate);
				setValue("tutorHours", props.fetchUserDetails.userdetails[0].tutorHours);
				setValue(
					"inputUworld",
					(props.fetchUserDetails.userdetails[0].subscriptions || []).includes("uworld")
					? "claimed"
					: "unclaimed"
				);
				setValue(
					"inputAamc",
					(props.fetchUserDetails.userdetails[0].subscriptions || []).includes("aamc")
					? "claimed"
					: "unclaimed"
				);

				setValue(
					"ultimateAdvisingStudent",
					typeof props.fetchUserDetails.userdetails[0][specFields.ultimateAdvisingStudent] !=
					"undefined"
					? props.fetchUserDetails.userdetails[0][specFields.ultimateAdvisingStudent]
					: false
				);
				setValue(
					"lifetimeAccess",
					typeof props.fetchUserDetails.userdetails[0][specFields.lifetimeAccess] !=
					"undefined"
					? props.fetchUserDetails.userdetails[0][specFields.lifetimeAccess]
					: false
				);
				setValue(
					"subscriptionEndDate",
					props.fetchUserDetails.userdetails[0][specFields.subscriptionEndDate]
					? new Date(props.fetchUserDetails.userdetails[0][specFields.subscriptionEndDate])
					: ""
				);
				setValue(
					"coach",
					typeof props.fetchUserDetails.userdetails[0].coach != "undefined"
					? props.fetchUserDetails.userdetails[0].coach
					: false
				);

				setValue(
					"assignedCoach",
					typeof props.fetchUserDetails.userdetails[0].assignedCoach !=
					"undefined"
					? props.fetchUserDetails.userdetails[0].assignedCoach
					: ""
				);
				if (
					typeof props.fetchUserDetails.userdetails[0].assignedCoach !=
					"undefined"
				) {
					setAssignedCoach(props.fetchUserDetails.userdetails[0].assignedCoach);
				} else {
					setAssignedCoach("");
				}

				setValue(
					"matriculated",
					typeof props.fetchUserDetails.userdetails[0].matriculated !=
					"undefined"
					? props.fetchUserDetails.userdetails[0].matriculated
					: ""
				);
				if (
					typeof props.fetchUserDetails.userdetails[0].matriculated !=
					"undefined"
				) {
					setSchool(props.fetchUserDetails.userdetails[0].matriculated);
				} else {
					setSchool("");
				}


				setValue(
					"proMemberStudent",
					typeof props.fetchUserDetails.userdetails[0].proMemberStudent !=
					"undefined"
					? props.fetchUserDetails.userdetails[0].proMemberStudent
					: false
				);

			}

		}
		
	}, [props.fetchUserDetails]);

	const toggleUpdateUser = () => {
		setModalUpdateUser(!modalUpdateUser);
	};

	const toggleUpdateMultiUsers = () => {
		setModalUpdateMultiUsers(!modalUpdateMultiUsers);
	};

	const editUserDetails = (e, data) => {
		e.preventDefault();
		setModalUpdateUser(data.modal);
		dispatch(fetchUserDetails({ userId: data.userId }));

		dispatch(fetchUniversities({}));

		setValue("name", "");
		setValue("email", "");
		setValue("homeAddress", "");
		setValue("tpcEntryDate", "");
		setValue("mcatDate", "");
		setValue("schoolYear", "");
		setValue("university", "");
		setValue("selectedCountry", "");
		setValue("selectedCity", "");
		setValue("selectedState", "");
		setValue("postalCode", "");
		setValue("tutorHours", "");
		setValue("shadowGoal", "");
		setValue("clinicalGoal", "");
		setValue("volunteerGoal", "");
		setValue("assignedCoach", "");
		setValue("subscriptionEndDate", "");

		// setValue("ultimateAdvisingStudent", "");
		// setValue("coach",  "");
	};

	const updateMultipleUsers = () => {
		setValue("tutorHours", "");
		setValue("assignedCoach", "");
		setAssignedCoach("");
		setValue("selectUsers", "");
		setValue("ultimateAdvisingStudent", "");
		setValue("lifetimeAccess", "");
		setValue("proMemberStudent", "");

		const fetchAllUsers = async () => {
			const querySnapshot = await getDocs(collection(db, "users"));
			let users = [];
			querySnapshot.forEach((doc) => {
				let v = doc.data();
				users.push({
				value: v.handle,
				label: v.name,
				image: typeof v.profilePicture != "undefined" ? v.profilePicture : "",
				});
			});
			users.unshift({ value: "", label: "Select Users" });
			setCheckUsers(users);
		};

		fetchAllUsers();

		setModalUpdateMultiUsers(true);
	};

	const onSubmitUpdate = (data) => {
		data.subscriptions = [];

		if (data.inputAamc == "claimed") {
		data.subscriptions.push("aamc");
		}
		if (data.inputUworld == "claimed") {
		data.subscriptions.push("uworld");
		}
		dispatch(updateMultiUsers(data));
	};

  //   const Checkbox = ({ obj, onChange }) => {
  //     return (
  //       <CustomInput
  //         type="checkbox"
  //         id={`custom-checkbox-${obj.handle}`}
  //         name={obj.handle}
  //         value={obj.checked}
  //         onChange={() => onChange({ ...obj, checked: !obj.checked })}
  //       />
  //     );
  //   };

	const onSubmit = (data) => {
		data.subscriptions = [];

		if (data.inputAamc == "claimed") {
		data.subscriptions.push("aamc");
		}
		if (data.inputUworld == "claimed") {
		data.subscriptions.push("uworld");
		}
		// Add admin handle and updatedBy fields for updatePremiumhours log
		data.handle = props.fetchUserDetails.userdetails[0].handle;
		data.updatedBy = props.userDetails.handle;
		data.specialty = props.activeSpecialty;
		const subEndDate = data.subscriptionEndDate;
		delete data.subscriptionEndDate;
		data[specFields.subscriptionEndDate] = subEndDate ? new Date(subEndDate).toISOString() : "";
		dispatch(updateUserDetails(data));
	};

	useEffect(() => {
		if (props.updateUserDetails.loading) {
		Swal.fire({
			allowOutsideClick: false,
			didOpen: () => {
			Swal.showLoading();
			},
		});
		} else {
		Swal.fire({
			title: "Success!",
			text: "Successfully updated user!",
			icon: "success",
			timer: 3000,
		}).then(() => {
			if (selectedUser?.userId) {
				dispatch(fetchUserDetails({ userId: selectedUser.userId }));
			}
		});
		}
	}, [props.updateUserDetails]);

	const handleViewUser = (e, userDetails) => {
		e.preventDefault();
		Swal.fire({
			title: "View as user",
			text: "Do you want to view as "+userDetails.name+"?",
			icon: "question",
			showCancelButton: true,
			confirmButtonText: "Yes",
			reverseButtons: true,
		}).then((result) => {
			if (result.isConfirmed) {
				dispatch(getUserData({ user: userDetails }));
			}
		});

	};

	const handleExtendToBoards = (e, user) => {
		e.preventDefault();
		setExtendUser(user);
		setExtendOption("boards");
		const endDate = user[specFields.subscriptionEndDate];
		setCustomDate(endDate ? moment(endDate) : "");
		setExtendModal(true);
	};

	const handleExtendSubmit = async () => {
		const user = extendUser;
		if (!user) return;

		const payload = { handle: user.handle || user.email, specialty: props.activeSpecialty };

		if (extendOption === "custom") {
			if (!customDate) {
				Swal.fire({ icon: "warning", title: "No date selected", text: "Please select a custom date." });
				return;
			}
			payload.customDate = moment(customDate).format("YYYY-MM-DD");
		}

		setExtendLoading(true);
		try {
			const res = await axios.post("/extendSubscriptionToBoards", payload);
			if (res.data.success) {
				Swal.fire({ icon: "success", title: "Extended", text: `Subscription extended to ${res.data.date}`, timer: 2000, showConfirmButton: false });
				const endDateField = specFields.subscriptionEndDate;
				setFilter(prev => prev.map(u =>
					(u.handle || u.email) === (user.handle || user.email)
						? { ...u, [endDateField]: res.data.date + 'T23:59:59.999Z' }
						: u
				));
				setData(prev => prev.map(u =>
					(u.handle || u.email) === (user.handle || user.email)
						? { ...u, [endDateField]: res.data.date + 'T23:59:59.999Z' }
						: u
				));
				setExtendModal(false);
			}
		} catch (err) {
			Swal.fire({ icon: "error", title: "Error", text: err.response?.data?.error || "Failed to extend subscription" });
		} finally {
			setExtendLoading(false);
		}
	};

   

	const [logsData, setLogsData] = useState([]);
    useEffect(() => {
        if (props.fetchAppHourUsedLogs.loading) {
        } else {
            if (props.fetchAppHourUsedLogs.logs.length) {
                setLogsData(props.fetchAppHourUsedLogs.logs)
            }else{
                setLogsData([]) 
            }	
        }
	}, [props.fetchAppHourUsedLogs]);


	const [subscription, setSubscription] = useState("");
	function handleSubscriptionFilterOnChange(e) {
		setSubscription(e.value);
	}

   	const [getByCoach, setGetByCoach] = useState("");
  	const  handleGetByCoach = (e) => {
    	setGetByCoach(e.value);
		 dispatch(
		fetchAllUsers({
				route: "",
				coachFilter: e.value,
			})
		);

  	}

	// useEffect(() => {
	// 	dispatch(
	// 		fetchAllUsers({
	// 			route: "",
	// 			coachFilter: getByCoach,
	// 		})
	// 	);
	// }, [getByCoach]);

	useEffect(() => {
		dispatch(
		fetchAllUsers({
			route: "",
			subscriptionFilter: subscription,
		})
		);
		dispatch(fetchCoaches({}));
	}, [subscription]);

	const handleAssignedCoach = (selectedOption) => {
		setAssignedCoach(selectedOption.value);
		setValue("assignedCoach", selectedOption.value);
	};

	const resetFilter = () => {
		dispatch(
		fetchAllUsers({
			route: "",
			subscriptionFilter: "",
		})
		);

		setSubscription("")
		setGetByCoach("")

	}
		const [coaches, setCoaches] = useState([]);
		const [coachOption, setCoachOption] = useState([]);
		const [assignedcoach, setAssignedCoach] = useState("");

	useEffect(() => {
		if (props.fetchCoaches.fetchcoaches.length) {
			const coachesArr = props.fetchCoaches.fetchcoaches[0];
			setCoaches(coachesArr);

			const coachesOption = props.fetchCoaches.fetchcoaches[0];
			coachesOption.unshift({ value: "", label: "Select Coach" });
			setCoachOption(coachesOption);
		}
	}, [props.fetchCoaches]);


	useEffect(() => {
		if(props.fetchUniversities.universities.length){
			let universitiesList = props.fetchUniversities.universities[0][0].universities.sort()

			universitiesList = [...new Set(universitiesList.map((value, index) => {return {value:value, label: value}}))];
			
			setUniversities(universitiesList)


			let medicalSchoolsList = props.fetchUniversities.universities[1][0].universities.sort()

			medicalSchoolsList = [...new Set(medicalSchoolsList.map((value, index) => {return {value:value, label: value}}))];
			
			setMedicalSchools(medicalSchoolsList)

		}
	}, [props.fetchUniversities.universities])

	const handleUniversityChange = (selectedOption) => {
		setValue("matriculated", selectedOption.value);
		setSchool(selectedOption.value);
	};

	 const useHoursObj = [
        {category: "personal_statement", value: Number(psValue), prev: 0, max: 7},
        {category: "activities", value: Number(actValue) , prev: 0, max: 5},
        {category: "mock_interview", value: Number(miValue) , prev: 0, max: 2},
        {category: "secondaries", value: Number(secValue) , prev: 0, max: 6},
        {category: "general_coaching", value: Number(generalValue) , prev: 0, max: 6},
    ];

	const convertDate = (date) => {
        return moment(date).utcOffset(0, false).format('ll');
    }

	// DataTable columns and styles removed - now using Reactstrap Table
	// const columns = [...];
	// const tableHeaderstyle = {...};

	const [sessionDate, setSessionDate] = useState("")
    const [sessionFrom, setSessionFrom] = useState("")
    const [sessionTo, setSessionTo] = useState("")
    
    const handleChangeDate = (e) =>{
		if(typeof e === "object"){
        	setSessionDate(new Date(e.toJSON()));
		}else{
			setSessionDate("");
		}
    }
    const handleChangeFrom = (e) =>{
		if(typeof e === "object"){
        	setSessionFrom(new Date(e.toJSON()));
		}else{
			setSessionFrom("")
		}
    }
    const handleChangeTo = (e) =>{
		if(typeof e === "object"){
			setSessionTo(new Date(e.toJSON()));
		}else{
			setSessionTo("")
		}    
    }


	const convertTimeToUTC = (time) => {
        return moment(moment(time).utcOffset(0, false), "HH:mm")
    }

    const convertTimeToLocal = (time) => {
        return moment(moment(time).utcOffset(0, true), "HH:mm")
    }

	const  saveUserSession = () =>{
        setHideError(false)

        let errors = 0
		if(!sessionDate || !sessionFrom || !sessionTo || !comment || !assignedcoach){
			errors = 1
		}else if(psValue === 0 && actValue === 0 && miValue === 0 && secValue === 0 && generalValue === 0 && phour === 0) {
			setNoValueError("Please input hour to a category to apply changes.")
			errors = 1
		}else if(Number(phour) > Number(selectedUser.tutorHours)){
			setPhour(0)
			errors = 1
			setHourErrorMsg( "Deduct hour should not be greater than the current value " )
		}else{
			errors = 0
		}


        if(typeof selectedUser.totalHoursUsed !== "undefined"){

            let updatedHour = []
           
            useHoursObj.forEach(function(d,i){
             
                if(typeof selectedUser.totalHoursUsed[i] !== "undefined"){
                    if(d.category == selectedUser.totalHoursUsed[i].category){
                        let updateValue =   Number(d.value) + Number(selectedUser.totalHoursUsed[i].value)
                        d.prev = selectedUser.totalHoursUsed[i].value
                        d.value = updateValue
                    }
                }
                updatedHour.push(d)
            });
          
            if(errors == 1){
              
            }else{
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You want to add hours?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes,'
                }).then((result) => {
                    if (result.isConfirmed) {
						setModal1(false)
                        const setData = {
                            by: props.userDetails.handle,
                            updatedBy: assignedcoach, //? assignedcoach : props.userDetails.handle,
                            handle: selectedUser.handle,
                            updateUsedHour: updatedHour,
                            date: moment.utc(sessionDate).format(),
                            startTime: moment.utc(sessionFrom).format(),
                            endTime: moment.utc(sessionTo).format(),
                            comment: comment,
                            mailDetails: {
                                coach: props.userDetails.name,
                                coachEmail: props.userDetails.email,
                                student: selectedUser.name,
                                studentEmail: selectedUser.email,

                            }
                        }
						if(phour != 0){
							setData.updatePremiumHour = {
								category: "premium_hour",
								prev: Number(selectedUser.tutorHours),
								value : Number(selectedUser.tutorHours) - Number(phour)
							}
						}
                        selectedUser.totalHoursUsed = updatedHour
						selectedUser.tutorHours = Number(selectedUser.tutorHours) - Number(phour)
                        calculateTotalHours(selectedUser)
						console.log(setData)
                        dispatch(updateUserDetails(setData));
						setSessionDate("")
						setSessionFrom("")
						setSessionTo("")
                        setPsValue(0)
                        setActValue(0)
                        setMiValue(0)
                        setSecValue(0)
                        setGeneralValue(0)
						setPhour(0)
						setSelectedHour(0)
                        dispatch(fetchAppHourUsedLogs({handle: selectedUser.handle}))
                        // dispatch(sendEmailApplicationHourUsed(setData))
                        setHideError(true)
                        setNoValueError("")
						setHourErrorMsg("")
                        setComment("")
                    
                    }
                })
            }
           

        }else{  
            if(errors == 1){
            }else{
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You want to add hours?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes,'
                }).then((result) => {
                    if (result.isConfirmed) {
						setModal1(false)
                        const setData = {
                            by: props.userDetails.handle,
                            updatedBy: assignedcoach, //? assignedcoach : props.userDetails.handle,
                            handle: selectedUser.handle,
                            updateUsedHour: useHoursObj,
							
                           	date: moment.utc(sessionDate).format(),
                            startTime: moment.utc(sessionFrom).format(),
                            endTime: moment.utc(sessionTo).format(),
                            comment: comment,
                            mailDetails: {
                                coach: props.userDetails.name,
                                coachEmail: props.userDetails.email,
                                student: selectedUser.name,
                                studentEmail: selectedUser.email,

                            }
                        }
						if(phour != 0){
							setData.updatePremiumHour = {
								category: "premium_hour",
								prev: Number(selectedUser.tutorHours),
								value : Number(selectedUser.tutorHours) - Number(phour)
							}
						
						}
                        selectedUser.totalHoursUsed = useHoursObj
						// console.log(setData)
                        calculateTotalHours(selectedUser)
                        dispatch(updateUserDetails(setData));
						setSessionDate("")
						setSessionFrom("")
						setSessionTo("")
                        setPsValue(0)
                        setActValue(0)
                        setMiValue(0)
                        setSecValue(0)
                        setGeneralValue(0)
						setPhour(0)
						setSelectedHour(0)
                        // dispatch(fetchAppHourUsedLogs({handle: selectedUser.handle}))
                        // dispatch(sendEmailApplicationHourUsed(setData))
                        setHideError(true)
                        setNoValueError("")
						setHourErrorMsg("")
                        setComment("")
        
                    }
                })
            }
        }

    }

	const calculateTotalHours = (selectedUser) =>{
         if(typeof selectedUser.totalHoursUsed !== "undefined"){
            let total = 0
            selectedUser.totalHoursUsed.map((v,i)=>(
                total+= Number(v.value)
            ))
            setTotalHour(total)
        }else{
            setTotalHour(0)
        }
    }

	const  editStudentDetails = (e,userID) =>{
		console.log(assignedcoach)
		setAssignedCoach("")
		setSessionDate()
        setSessionFrom()
        setSessionTo()
        setComment()
		setPsValue(0)
        setActValue(0)
		setMiValue(0)
      	setSecValue(0)
        setGeneralValue(0)
		setPhour(0)
		setSelectedHour(0)
        setHideError(true)
        setNoValueError("")
		setHourErrorMsg("")
        setSelectedUser([])
        dispatch(fetchUserDetails({ userId: userID }));
        setModal1(true)
    }

	const managePremiumHours = (e,userID) =>{

		setAssignedCoach("")
		setHideError(true)
		setSessionDate()
        setSessionFrom()
        setSessionTo()
        setComment()
        dispatch(fetchUserDetails({ userId: userID }));
        setModal2(true)
    }

	const [modal1, setModal1] = useState(false);
    const modalToggle1 = () => setModal1(!modal1);
    const [backdrop1, setBackdrop1] = useState(true);

	const [modal2, setModal2] = useState(false);
    const modalToggle2 = () => setModal2(!modal2);
    const [backdrop2, setBackdrop2] = useState(true);

	const hourOptions = [
        {
            label: '.5',
            value: '0.5',
        },
        {
            label: '.75',
            value: '0.75',
        },
        {
            label: '1',
            value: '1',
        },
        {
            label: '1.5',
            value: '1.5',
        },
        {
            label: '2',
            value: '2',
        },
    ];

    const handleHours = (data) =>{
        console.log(data)
        if(data.category == "personal_statement"){
            setPsValue(data.value)
        }else if(data.category == "activities"){
            setActValue(data.value)
        }
        else if(data.category == "mock_interview"){
            setMiValue(data.value)
        }else if(data.category == "secondaries"){
            setSecValue(data.value)
        }else if(data.category == "general_coaching"){
            setGeneralValue(data.value)
        }else{
			setPhour(data.value)

		}
        setNoValueError("")
    }

	const [noValueError, setNoValueError] = useState()
	const [hideError, setHideError] = useState(true)
    const [hourErrorMsg,setHourErrorMsg] = useState("")
    const [phour, setPhour] = useState(0)

    const handleHourChange = (e) => {
        const hvalue = e.target.value
        setPhour(hvalue)   
    }

    const [comment, setComment] = useState("")
    const handleCommentChange = (e) =>{
        setComment(e.target.value)
    }

    const logPremiumHour = (e,mode) => {
        setHideError(false)
    
        let caclHour = 0
        let errors = 0
		//    if(props.userDetails.admin){
		// 		if(!phour || !comment || !assignedcoach){
		// 			errors = 1
		// 		}else{
		// 			errors = 0
		// 		}
		// 	}else{
		// 		if(!assignedcoach || !phour || !comment || !sessionDate || !sessionFrom || !sessionTo ){
		// 			errors = 1
		// 		}else{
		// 			errors = 0
		// 		}
		// 	}
		if(!assignedcoach || !phour || !comment || !sessionDate || !sessionFrom || !sessionTo ){
			errors = 1
		}else{
			errors = 0
		}
		
		if(Number(phour) > Number(selectedUser.tutorHours)){
			setPhour("")
			errors = 1
			setHourErrorMsg( "Deduct hour should not be greater than the current value " )
		}
            
        caclHour =  Number(selectedUser.tutorHours) - Number(phour)
        if(errors == 1){
            
        }else{
            const logs = {
                by: props.userDetails.handle,
                coachHandle: assignedcoach,// ? assignedcoach : props.userDetails.handle,
                handle: selectedUser.handle,
                premItem: {
                    previousHour : selectedUser.tutorHours,
                    mode: mode,
                    hour: phour,
                    currentTotal: String(caclHour),
                    comment: comment,
					date: moment.utc(sessionDate).format(),
					startTime: moment.utc(sessionFrom).format(),//convertTimeToUTC(sessionFrom).format(), 
					endTime: moment.utc(sessionTo).format(),
                },
                mailDetails: {
                    coach: props.userDetails.name,
                    coachEmail: props.userDetails.email,
                    student: selectedUser.name,
                    studentEmail: selectedUser.email,
                }
            }
            dispatch(updateUserDetails(logs));
            selectedUser.tutorHours= String(caclHour)
			setSessionDate("")
			setSessionFrom("")
			setSessionTo("")
            setPhour("")
            setComment("")
            setAssignedCoach("")
            setHideError(true)
            // dispatch(fetchPremiumHourLogs({handle: selectedUser.handle}))
            // dispatch(sendEmailApplicationHourUsed(logs))
        }
    }

	

	useEffect(() => {
		let result = data.filter((item) => {
			if(item){
				return (
					modifiedSearch(item.email).match(search.toLocaleLowerCase()) ||
					modifiedSearch(item.name).match(search.toLocaleLowerCase()) ||
					modifiedSearch(item[specFields.pmrProgram]).match(search.toLocaleLowerCase()) ||
					modifiedSearch(item[specFields.year]).match(search.toLocaleLowerCase())
				)
			}
		});

		// Plan filter
		if (planFilter) {
			result = result.filter((user) => {
				const plan = getUserPlan(user, specFields);
				if (planFilter === "No Plan") return plan === "-";
				if (planFilter === "Trial") return plan === "Trial";
				return plan.startsWith(planFilter);
			});
		}

		// Status filter
		if (statusFilter) {
			result = result.filter((user) => {
				return getStatusCategory(user, specFields) === statusFilter;
			});
		}

		// Year filter
		if (yearFilter) {
			result = result.filter((user) => user[specFields.year] === yearFilter);
		}

		// Program filter
		if (programFilter) {
			result = result.filter((user) => user[specFields.pmrProgram] === programFilter);
		}

    	setFilter(result);
		setCurrentPage(1); // Reset to first page on search/filter

	}, [search, planFilter, statusFilter, yearFilter, programFilter, data]);

	// Build unique program list from data
	const programOptions = React.useMemo(() => {
		const programs = [...new Set(data.map(u => u[specFields.pmrProgram]).filter(Boolean))].sort();
		return programs;
	}, [data]);

	// Sort handler
	const handleSort = (field) => {
		if (sortField === field) {
			setSortDirection(prev => prev === "asc" ? "desc" : "asc");
		} else {
			setSortField(field);
			setSortDirection("asc");
		}
	};

	// Sort the filter array
	const sortedFilter = React.useMemo(() => {
		const sorted = [...filter];
		const dir = sortDirection === "asc" ? 1 : -1;
		sorted.sort((a, b) => {
			switch (sortField) {
				case "name":
					return dir * (a.name || "").localeCompare(b.name || "");
				case "email":
					return dir * (a.email || "").localeCompare(b.email || "");
				case "plan":
					return dir * (getPlanRank(a, specFields) - getPlanRank(b, specFields));
				case "status":
					return dir * (getStatusRank(a, specFields) - getStatusRank(b, specFields));
				case "expires":
					return dir * (getExpiresDate(a, specFields) - getExpiresDate(b, specFields));
				case "year":
					return dir * (a[specFields.year] || "").localeCompare(b[specFields.year] || "");
				case "program":
					return dir * (a[specFields.pmrProgram] || "").localeCompare(b[specFields.pmrProgram] || "");
				default:
					return 0;
			}
		});
		return sorted;
	}, [filter, sortField, sortDirection]);

	// Sort icon helper
	const sortIcon = (field) => {
		if (sortField !== field) return "fas fa-sort";
		return sortDirection === "asc" ? "fas fa-sort-up" : "fas fa-sort-down";
	};

	// Export handler
	const handleExport = async () => {
		try {
			const workbook = new ExcelJS.Workbook();
			workbook.creator = getSpecialty(props.activeSpecialty).name + " Prep";
			workbook.created = new Date();

			const worksheet = workbook.addWorksheet("Users");
			worksheet.columns = [
				{ header: "Name", key: "name", width: 25 },
				{ header: "Email", key: "email", width: 30 },
				{ header: "Plan", key: "plan", width: 18 },
				{ header: "Status", key: "status", width: 15 },
				{ header: "Expires", key: "expires", width: 18 },
				{ header: "Year", key: "year", width: 10 },
				{ header: "Program", key: "program", width: 30 },
			];

			// Style header row
			const headerRow = worksheet.getRow(1);
			headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
			headerRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF5E72E4" } };
			headerRow.alignment = { vertical: "middle" };

			sortedFilter.forEach((user) => {
				const status = getUserStatus(user, specFields);
				worksheet.addRow({
					name: user.name || "",
					email: user.email || "",
					plan: getUserPlan(user, specFields),
					status: status.label === "Active" || status.label === "Expired" || status.label === "No Access" ? status.label : `${status.label} remaining`,
					expires: getUserExpires(user, specFields),
					year: user[specFields.year] || "-",
					program: user[specFields.pmrProgram] || "-",
				});
			});

			const buffer = await workbook.xlsx.writeBuffer();
			const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.download = `PMR_Prep_Users_Export_${new Date().toISOString().slice(0, 10)}.xlsx`;
			link.click();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error("Export failed:", error);
			Swal.fire("Error", "Failed to export users.", "error");
		}
	};

	const modifiedSearch = (item) =>  {
		if(item !== undefined){
			if(item.name !== undefined){
				return  item.name.toLowerCase()
			} 
			return  item.toLowerCase()
		}else{
			return '';
		}
	}

	 //Tabs
    const mainopt = ["Log Hours", "View History"];
    const [mainActiveTab, setMainActiveTab] = useState("Log Hours");

    const toggleMain = (tab) => {
        if (mainActiveTab !== tab) setMainActiveTab(tab);
    };

	const onChangeUltimateAdvisingStudent = (e) => {
   

        if(e.target.value === "true" || e.target.value === true  ){
            setValue("tutorHours", parseInt(props.fetchUserDetails.userdetails[0].tutorHours) + 5)         
        }
        else{
            setValue("tutorHours", parseInt(props.fetchUserDetails.userdetails[0].tutorHours))
        }

        setValue("ultimateAdvisingStudent", e.target.value)
    }


  return (
		<>
			<Header></Header>
			<Container className="mt--7" fluid>
				<Row>
					<Col>
						<Card className="shadow">
						<CardHeader className="border-0">
							<Row>
							<Col md="12">
								<button
								className="btn btn-primary float-right"
								onClick={(e) => updateMultipleUsers(e)}
								>
								Update Multiple Users
								</button>
								<button
								className="btn btn-success float-right mr-2"
								onClick={toggleCreateUser}
								>
								<i className="fas fa-plus mr-1"></i>
								Create Account
								</button>
								<button
								className="btn btn-warning float-right mr-2"
								onClick={openPromoModal}
								>
								<i className="fas fa-graduation-cap mr-1"></i>
								Year Promotion
								</button>
							</Col>
							</Row>
							{/* Filter By Subscription and Filter By Coach removed - no longer needed */}
							
						</CardHeader>
							<Row>
								<Col>
									<Card className="shadow">
										<CardBody>
											{loading ? (
												<div className="m-5">
													<Alert color="secondary" className="text-center">
														Collecting data.. Please wait while loading {" "}
														<Spinner size="sm" color="primary" />{" "}
													</Alert>
												</div>
											) : data.length ? (
												<>
													<Row className="mb-2">
														<Col md="4">
															<Input
																type="text"
																placeholder="Search by name, email, program..."
																value={search}
																onChange={(e) => setSearch(e.target.value)}
															/>
														</Col>
													</Row>
													<Row className="mb-3 align-items-center">
														<Col md="2" className="mb-2">
															<Select
																options={[
																	{ value: "", label: "All Plans" },
																	{ value: "Lifetime", label: "Lifetime" },
																	{ value: "UAS", label: "UAS" },
																	{ value: "1 Month", label: "1 Month" },
																	{ value: "3 Months", label: "3 Months" },
																	{ value: "6 Months", label: "6 Months" },
																	{ value: "12 Months", label: "12 Months" },
																	{ value: "18 Months", label: "18 Months" },
																	{ value: "24 Months", label: "24 Months" },
																	{ value: "36 Months", label: "36 Months" },
																	{ value: "48 Months", label: "48 Months" },
																	{ value: "Trial", label: "Trial" },
																	{ value: "No Plan", label: "No Plan" },
																]}
																value={{ value: planFilter, label: planFilter || "All Plans" }}
																onChange={(opt) => setPlanFilter(opt ? opt.value : "")}
																styles={customDropdownWithBorder}
																placeholder="All Plans"
															/>
														</Col>
														<Col md="2" className="mb-2">
															<Select
																options={[
																	{ value: "", label: "All Status" },
																	{ value: "Active", label: "Active" },
																	{ value: "Expiring Soon", label: "Expiring Soon" },
																	{ value: "Expired", label: "Expired" },
																	{ value: "No Access", label: "No Access" },
																]}
																value={{ value: statusFilter, label: statusFilter || "All Status" }}
																onChange={(opt) => setStatusFilter(opt ? opt.value : "")}
																styles={customDropdownWithBorder}
																placeholder="All Status"
															/>
														</Col>
														<Col md="2" className="mb-2">
															<Select
																options={[
																	{ value: "", label: "All Years" },
																	{ value: "Fellow", label: "Fellow" },
																	{ value: "PGY 1", label: "PGY 1" },
																	{ value: "PGY 2", label: "PGY 2" },
																	{ value: "PGY 3", label: "PGY 3" },
																	{ value: "PGY 4", label: "PGY 4" },
																]}
																value={{ value: yearFilter, label: yearFilter || "All Years" }}
																onChange={(opt) => setYearFilter(opt ? opt.value : "")}
																styles={customDropdownWithBorder}
																placeholder="All Years"
															/>
														</Col>
														<Col md="2" className="mb-2">
															<Select
																options={[
																	{ value: "", label: "All Programs" },
																	...programOptions.map((p) => ({ value: p, label: p }))
																]}
																value={{ value: programFilter, label: programFilter || "All Programs" }}
																onChange={(opt) => setProgramFilter(opt ? opt.value : "")}
																styles={customDropdownWithBorder}
																placeholder="All Programs"
															/>
														</Col>
														<Col md="2" className="mb-2">
															<Button
																color="success"
																onClick={handleExport}
																disabled={sortedFilter.length === 0}
																title="Export filtered users to Excel"
																className="w-100"
															>
																<i className="fas fa-file-excel mr-1"></i>
																Export
															</Button>
														</Col>
													</Row>
													{sortedFilter.length === 0 ? (
														<Alert color="warning">
															<i className="fas fa-search mr-2"></i>
															No users found matching the current filters{search ? ` and "${search}"` : ""}
														</Alert>
													) : (
														<>
															<Table className="align-items-center table-flush" responsive>
																<thead className="thead-light">
																	<tr>
																		<th>Action</th>
																		<th style={{ cursor: "pointer" }} onClick={() => handleSort("name")}>Name <i className={sortIcon("name")} style={{ opacity: sortField === "name" ? 1 : 0.3 }}></i></th>
																		<th style={{ cursor: "pointer" }} onClick={() => handleSort("email")}>Email <i className={sortIcon("email")} style={{ opacity: sortField === "email" ? 1 : 0.3 }}></i></th>
																		<th style={{ cursor: "pointer" }} onClick={() => handleSort("plan")}>Plan <i className={sortIcon("plan")} style={{ opacity: sortField === "plan" ? 1 : 0.3 }}></i></th>
																		<th style={{ cursor: "pointer" }} onClick={() => handleSort("status")}>Status <i className={sortIcon("status")} style={{ opacity: sortField === "status" ? 1 : 0.3 }}></i></th>
																		<th style={{ cursor: "pointer" }} onClick={() => handleSort("expires")}>Expires <i className={sortIcon("expires")} style={{ opacity: sortField === "expires" ? 1 : 0.3 }}></i></th>
																		<th style={{ cursor: "pointer" }} onClick={() => handleSort("year")}>Year <i className={sortIcon("year")} style={{ opacity: sortField === "year" ? 1 : 0.3 }}></i></th>
																		<th style={{ cursor: "pointer" }} onClick={() => handleSort("program")}>Program <i className={sortIcon("program")} style={{ opacity: sortField === "program" ? 1 : 0.3 }}></i></th>
																	</tr>
																</thead>
																<tbody>
																	{sortedFilter
																		.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
																		.map((user) => {
																		const status = getUserStatus(user, specFields);
																		return (
																		<tr key={user.userId}>
																			<td>
																				<div className="d-flex">
																					<Button
																						color="secondary"
																						size="sm"
																						className="mr-1"
																						onClick={(e) => handleViewUser(e, user)}
																						title="View as user"
																					>
																						<i className="fas fa-eye"></i>
																					</Button>
																					<Button
																						color="info"
																						size="sm"
																						className="mr-1"
																						onClick={(e) => editUserDetails(e, { modal: true, userId: user.userId })}
																						title="Edit user"
																					>
																						<i className="fas fa-edit"></i>
																					</Button>
																					<Button
																						color="success"
																						size="sm"
																						onClick={(e) => handleExtendToBoards(e, user)}
																						title="Extend subscription to boards exam date"
																					>
																						<i className="fas fa-calendar-plus"></i>
																					</Button>
																				</div>
																			</td>
																			<td>
																				<div className="d-flex align-items-center">
																					{user.profilePicture ? (
																						<img
																							className="rounded-circle mr-2"
																							style={{ width: "32px", height: "32px", objectFit: "cover" }}
																							src={"https://storage.googleapis.com/pmr-bank.firebasestorage.app/profile-picture/" + user.profilePicture}
																							alt=""
																						/>
																					) : (
																						<div className="rounded-circle profile-letter-all-users mr-2"
																							style={{ width: "32px", height: "32px", fontSize: "13px" }}>
																							{user.name ? user.name.trim()[0].toUpperCase() : ""}
																						</div>
																					)}
																					{user.name}
																				</div>
																			</td>
																			<td>{user.email}</td>
																			<td>{getUserPlan(user, specFields)}</td>
																			<td><Badge color={status.color}>{status.label}</Badge></td>
																			<td>{getUserExpires(user, specFields)}</td>
																			<td>{user[specFields.year] || "-"}</td>
																			<td>{user[specFields.pmrProgram] || "-"}</td>
																		</tr>
																		);
																	})}
																</tbody>
															</Table>
															<div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mt-3">
																<div className="text-muted small mb-2 mb-sm-0">
																	Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, sortedFilter.length)} of {sortedFilter.length} users
																</div>
																<div className="d-flex align-items-center">
																	<Button
																		color="primary"
																		size="sm"
																		onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
																		disabled={currentPage === 1}
																		className="mr-2"
																	>
																		<i className="fas fa-chevron-left"></i>
																		<span className="d-none d-sm-inline ml-1">Previous</span>
																	</Button>
																	<span className="mx-2 text-nowrap">
																		Page {currentPage} of {Math.ceil(sortedFilter.length / itemsPerPage) || 1}
																	</span>
																	<Button
																		color="primary"
																		size="sm"
																		onClick={() => setCurrentPage(prev => Math.min(Math.ceil(sortedFilter.length / itemsPerPage), prev + 1))}
																		disabled={currentPage >= Math.ceil(sortedFilter.length / itemsPerPage)}
																		className="ml-2"
																	>
																		<span className="d-none d-sm-inline mr-1">Next</span>
																		<i className="fas fa-chevron-right"></i>
																	</Button>
																</div>
															</div>
														</>
													)}
												</>
											) : (
												<Alert color="primary">No data available.</Alert>
											)}
										</CardBody>
									</Card>
								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</Container>

			<Modal
				className="modal-dialog-centered"
				size="lg"
				isOpen={modalUpdateUser}
				toggle={toggleUpdateUser}
			>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<ModalBody className="modal-body p-0">
						<Card className="bg-secondary shadow border-0">
						<CardHeader className="bg-transparent">
							<Row className="align-items-center">
							<Col xs="8">
								<h3 className="mb-0">Edit User</h3>
							</Col>
							<Col className="text-right" xs="4"></Col>
							</Row>
						</CardHeader>
						<CardBody style={{ maxHeight: "650px", overflowY: "auto" }}>
							<h6 className="heading-small text-muted mb-4">
							User Information
							</h6>
							<div className="pl-lg-4">
							<Row>
								<Col lg="6">
								<FormGroup>
									<label className="form-control-label" htmlFor="name">
									Full Name
									</label>
									<Input
									className="form-control-alternative"
									id="name"
									name="name"
									value={watch("name") || ""}
									type="text"
									onChange={(e) => setValue("name", e.target.value)}
									/>
								</FormGroup>
								</Col>
								<Col lg="6">
								<FormGroup>
									<label className="form-control-label" htmlFor="email">
									Email Address
									</label>
									<Input
									className="form-control-alternative"
									id="email"
									name="email"
									value={watch("email") || ""}
									type="text"
									disabled
									/>
								</FormGroup>
								</Col>
								{props.activeSpecialty === "pmr" && (
								<Col lg="6">
								<FormGroup>
									<label
									className="form-control-label"
									htmlFor="year"
									>
									Year
									</label>
									<Select
									options={yearOptions}
									value={yearOptions.find((o) => o.value === watch("year")) || null}
									onChange={(opt) => setValue("year", opt ? opt.value : "")}
									styles={customDropdownWithBorder}
									placeholder="Select Year"
									isClearable
									/>
								</FormGroup>
								</Col>
								)}
								<Col lg="6">
								<FormGroup>
									<label
									className="form-control-label"
									htmlFor="pmrProgram"
									>
									{getSpecialty(props.activeSpecialty).name} Program
									</label>
									<Select
									options={pmrProgramOptions}
									value={pmrProgramOptions.find((o) => o.value === watch("pmrProgram")) || null}
									onChange={(opt) => setValue("pmrProgram", opt ? opt.value : "")}
									styles={customDropdownWithBorder}
									placeholder="Select Program"
									isClearable
									/>
								</FormGroup>
								</Col>
							</Row>
							</div>

							<hr className="my-4" />

							<h6 className="heading-small text-muted mb-4">
							Contact Information
							</h6>
							<div className="pl-lg-4">
							<Row>
								<Col lg="6">
								<FormGroup>
									<label
									className="form-control-label"
									htmlFor="phoneNumber"
									>
									Phone Number (U.S.)
									</label>
									<Input
									className="form-control-alternative"
									id="phoneNumber"
									name="phoneNumber"
									value={watch("phoneNumber") || ""}
									type="text"
									onChange={(e) => setValue("phoneNumber", e.target.value)}
									/>
								</FormGroup>
								</Col>
								<Col lg="6">
								<FormGroup>
									<label
									className="form-control-label"
									htmlFor="homeAddress"
									>
									Address
									</label>
									<Input
									className="form-control-alternative"
									id="homeAddress"
									name="homeAddress"
									value={watch("homeAddress") || ""}
									type="text"
									onChange={(e) => setValue("homeAddress", e.target.value)}
									/>
								</FormGroup>
								</Col>
								<Col lg="6">
								<FormGroup>
									<label
									className="form-control-label"
									htmlFor="selectedCountry"
									>
									Country
									</label>
									<Input
									className="form-control-alternative"
									id="selectedCountry"
									name="selectedCountry"
									value={watch("selectedCountry") || ""}
									type="text"
									onChange={(e) => setValue("selectedCountry", e.target.value)}
									/>
								</FormGroup>
								</Col>
								<Col lg="6">
								<FormGroup>
									<label
									className="form-control-label"
									htmlFor="selectedState"
									>
									State
									</label>
									<Input
									className="form-control-alternative"
									id="selectedState"
									name="selectedState"
									value={watch("selectedState") || ""}
									type="text"
									onChange={(e) => setValue("selectedState", e.target.value)}
									/>
								</FormGroup>
								</Col>
								<Col lg="6">
								<FormGroup>
									<label
									className="form-control-label"
									htmlFor="selectedCity"
									>
									City
									</label>
									<Input
									className="form-control-alternative"
									id="selectedCity"
									name="selectedCity"
									value={watch("selectedCity") || ""}
									type="text"
									onChange={(e) => setValue("selectedCity", e.target.value)}
									/>
								</FormGroup>
								</Col>
								<Col lg="6">
								<FormGroup>
									<label
									className="form-control-label"
									htmlFor="postalCode"
									>
									Postal Code
									</label>
									<Input
									className="form-control-alternative"
									id="postalCode"
									name="postalCode"
									value={watch("postalCode") || ""}
									type="text"
									onChange={(e) => setValue("postalCode", e.target.value)}
									/>
								</FormGroup>
								</Col>
							</Row>
							</div>

							<hr className="my-4" />

							<h6 className="heading-small text-muted mb-4">
							Access Control
							</h6>
							<div className="pl-lg-4">
							<Row>
								<Col lg="6">
								<FormGroup>
									<label
									className="form-control-label"
									htmlFor="lifetimeAccess"
									>
									Lifetime Access (Bypass Payment)
									</label>
									<Select
									options={[
										{ value: "false", label: "No" },
										{ value: "true", label: "Yes" },
									]}
									value={
										[
											{ value: "false", label: "No" },
											{ value: "true", label: "Yes" },
										].find((o) => o.value === String(watch("lifetimeAccess") || "false")) || null
									}
									onChange={(opt) => setValue("lifetimeAccess", opt ? opt.value : "false")}
									styles={customDropdownWithBorder}
									placeholder="Select"
									/>
									<small className="text-muted">Grant permanent full access without requiring payment</small>
								</FormGroup>
								</Col>
								<Col lg="6">
								<FormGroup>
									<label
									className="form-control-label"
									htmlFor="subscriptionEndDate"
									>
									Subscription Expiration Date
									</label>
									<div className="d-flex align-items-center">
									<div className="flex-grow-1">
									<ReactDatetime
									className="w-100"
									inputProps={{
										className: "form-control form-control-alternative",
										placeholder: "Select expiration date",
										id: "subscriptionEndDate",
										autoComplete: "off",
									}}
									timeFormat={false}
									dateFormat="MMMM D, YYYY"
									value={watch("subscriptionEndDate") || ""}
									onChange={(date) => setValue("subscriptionEndDate", date)}
									closeOnSelect={true}
									/>
									</div>
									{watch("subscriptionEndDate") && (
									<Button
										color="link"
										size="sm"
										className="text-danger ml-2 px-2"
										onClick={() => setValue("subscriptionEndDate", "")}
										title="Clear expiration date"
										type="button"
									>
										<i className="fas fa-times"></i>
									</Button>
									)}
									</div>
									<small className="text-muted">Set or extend the user's subscription end date</small>
								</FormGroup>
								</Col>
							</Row>
							</div>

							<hr className="my-4" />
							<AdminUserSubscription selectedUser={selectedUser} activeSpecialty={props.activeSpecialty} onRefresh={() => selectedUser?.userId && dispatch(fetchUserDetails({ userId: selectedUser.userId }))} />
						</CardBody>
						</Card>
					</ModalBody>
					<ModalFooter>
						<Button color="primary" type="submit">
						Update
						</Button>{" "}
						<Button color="secondary" onClick={toggleUpdateUser}>
						Close
						</Button>
					</ModalFooter>
				</Form>
			</Modal>

			<Modal
				className="modal-dialog-centered"
				size="lg"
				isOpen={modalUpdateMultiUsers}
				toggle={toggleUpdateMultiUsers}
			>
				<ModalHeader toggle={toggleUpdateMultiUsers}>Update Users</ModalHeader>
				<Form onSubmit={handleSubmit(onSubmitUpdate)}>
				<ModalBody className="modal-body ">
					<Row>
					<Col>
						<FormGroup>
						<Select
							isMulti
							name="selectusers"
							options={checkUsers}
							className="basic-multi-select"
							classNamePrefix="select"
							onChange={selectUsers}
							formatOptionLabel={(v) => (
							<div className="d-flex ">
								{v.value ? (
								v.image ? (
									<img
									className="rounded-circle  mr-1 "
									style={{ width: "25px", height: "25px" }}
									src={
										"https://storage.googleapis.com/pmr-bank.firebasestorage.app/profile-picture/" +
										v.image
									}
									alt={v.label}
									/>
								) : (
									<div
									className="rounded-circle profile-letter-all-users mr-1 "
									style={{ width: "25px", height: "25px" }}
									>
									{v.label ? v.label.trim()[0] : ""}
									</div>
								)
								) : (
								""
								)}

								<span>{v.label}</span>
							</div>
							)}
						/>
						</FormGroup>
					</Col>
					</Row>

					<Row>
					<Col>
						<h6 className="heading-small text-muted">
						Update The Information of the selected users
						</h6>
					</Col>
					</Row>

					<Row className="p-3">
					<Col lg="6">
						<FormGroup>
						<label
							className="form-control-label"
							htmlFor="lifetimeAccess"
						>
							Lifetime Access (Bypass Payment)
						</label>

						<select
							id="lifetimeAccess"
							name="lifetimeAccess"
							className="form-control form-control-alternative"
							onChange={(e) =>
								setValue("lifetimeAccess", e.target.value)
							}
							value={watch("lifetimeAccess")}

						>
							<option value="false">No</option>
							<option value="true">Yes</option>
						</select>
						<small className="text-muted">Grant permanent full access without requiring payment</small>
						</FormGroup>
					</Col>
					</Row>
					{/* <Form>
					<div
					className=""
					style={{ maxHeight: "500px", overflow: "scroll" }}
					>
					{
						checkUsers.length
						? checkUsers.map((v, i) => {
						
							return (
							<div className="d-flex align-items-center justify-content-between">
								<div className="media m-1">
								{typeof v.profilePicture != "undefined" ? (
									<img
									src={
										"https://storage.googleapis.com/pmr-bank.firebasestorage.app/profile-picture/" +
										v.profilePicture
									}
									className="mr-3 rounded-circle"
									alt="..."
									style={{
										width: "30px",
										height: "30px",
									}}
									/>
								) : (
									<div
									className="rounded-circle profile-letter-all-users mr-3 "
									style={{ width: "30px", height: "30px" }}
									>
									{v.name ? v.name.trim()[0] : ""}
									</div>
								)}

								<div className=" d-flex align-items-center ">
									<h5 className="mt-0 mb-0">
									{v.name ? v.name : ""}{" "}
									{v.coach || v.coach == "true" ? (
										<Badge
										className="ml-2 text-dark"
										color="info"
										pill
										>
										Coach
										</Badge>
									) : (
										""
									)}
									</h5>
								</div>
								</div>
								<div>
								<FormGroup>
									<Checkbox
									obj={v}
									onChange={(item) => {
										setCheckUsers(
										checkUsers.map((d) =>
											d.handle === item.handle ? item : d
										)
										);
									}}
									/>
								</FormGroup>
								</div>
							</div>
							);
							
						})
						: ""
						}
					</div>
				</Form> */}
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={toggleUpdateMultiUsers}>
					Cancel
					</Button>
					<Button color="success" type="submit">
					Update
					</Button>
				</ModalFooter>
				</Form>
			</Modal>
			<Modal
                isOpen={modal1}
                toggle={modalToggle1}
                backdrop={backdrop1}
                size="lg"
                centered
            >
                <ModalHeader toggle={modalToggle1}>
                    Manage Student's Log Hours
                </ModalHeader>
                 <ModalBody className="pt-1">
					 <Row>
                        <Col className="mt-3 mb-4 d-flex justify-content-center">
                            <Nav fill pills>
                                { mainopt.length > 0
                                    ? mainopt.map((c, i) => {
                                        return (
                                        <NavItem className="ml-1" key={i}>
                                            <NavLink
                                            key={c}
                                            className={classnames({
                                                active: mainActiveTab === c,
                                            })}
                                            onClick={() => {
                                                toggleMain(c);
                                            }}
                                            style={{ cursor: "pointer" }}
                                            >
                                            {c}
                                            </NavLink>
                                        </NavItem>
                                        );
                                    })
                                    :  ""
                                }
                            </Nav>
                        </Col>
                    </Row>
					<Row>
						<Col lg="12" className="mt-3 p-2">
							<TabContent activeTab={mainActiveTab}>
								{mainopt.map((mc, i) => (
									<TabPane tabId={mc} key={i}>
										{
											mc == "Log Hours" ?
												userDetailsLoading ? 

													<div className="m-5">
														<Alert color="secondary" className="text-center">
															Fetching student details.. Please wait while loading {" "}
															<Spinner size="sm" color="primary" />{" "}
														</Alert>
													</div>
												:
												<>
													<Card className="mb-2 shadow">
														<CardBody>
															
															<Row>
																<Col xl="6" className="d-flex align-items-center">
																	{
																		selectedUser ? 
																			<Media className="align-items-center">
																				{
																					typeof selectedUser.profilePicture != "undefined" ? (
																						<div className="media">
																							<img 
																								src={"https://storage.googleapis.com/pmr-bank.firebasestorage.app/profile-picture/" + selectedUser.profilePicture}
																								className="mr-3" 
																								alt="..." 
																								style={{
																									width: "60px",
																									height: "60px", 
																								}}
																							/>
																							<div className="media-body">
																								<h4 className="mt-0">{selectedUser.name}</h4>
																								<small>{selectedUser.email}</small>
																							
																							</div>
																						</div>
																				
																					) : 
																					(
																						<div className="media">
																							<div className="rounded-circle profile-letter-all-users mr-2" 
																								style={{
																								width: "60px",
																								height: "60px",
																									fontSize: "16px"
																									}}>
																									{selectedUser.name !== undefined ? selectedUser.name.trim()[0].toUpperCase() : "1" }
																							</div>
																							<div className="media-body">
																								<h5 className="my-0">{selectedUser.name}</h5>
																								<small>{selectedUser.email}</small>
																							
																							</div>
																						</div>
																					)
																				}
																				
																			</Media>
																		: ""
																	}
																</Col>
																<Col xl="6"  className="mt-2">
																	<Card className="card-stats mb-4 mb-xl-1 w-100 shadow">
																		<CardBody>
																			<Row>
																				<div className="col">
																					<CardTitle
																						tag="h5"
																						className="text-uppercase mb-0"
																					>
																						Application Hours Used
																					</CardTitle>
																				
																				</div>
																				<Col className="col-auto">
																					<span className="h2 font-weight-bold mb-0">
																						{totalHour}
																					</span>
																					{/* <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
																						<i className="fas fa-atom" />
																					</div> */}
																				</Col>
																			</Row>
																		</CardBody>
																	</Card>
																</Col>
															</Row>
														
														</CardBody>
													</Card>
													
													<Row className="mt-3" >
													
														<Col lg="6" >
															<FormGroup>
																<Label >Date <span className="text-danger">*</span></Label>
																<ReactDatetime
																	onChange={(e) => handleChangeDate(e)}
																	timeFormat={false}
																	value={sessionDate || ""} 
																	className="w-100"
																	inputProps={{ placeholder: "Select Date" }}
																	
																/>
																<Input
																	type="hidden"
																	onChange={(e) => handleChangeDate(e)}
																	value={sessionDate} 
																	invalid={!hideError ? sessionDate ? "" : "true" : ""}
																/>
																<FormFeedback>This field is required!</FormFeedback>
															</FormGroup>
															
															<FormGroup >
																<Label >From <span className="text-danger">*</span></Label>
																<ReactDatetime
																	value={sessionFrom}
																	onChange={(e) => handleChangeFrom(e)}
																	timeConstraints={{
																	minutes: { min: 30, max: 30, step: 31 },
																	}}
																	dateFormat={false}
																	className="w-100"
																	inputProps={{ placeholder: "Select Start Time" }}
																	
																/>
																<Input
																	type="hidden"
																	value={sessionFrom}  
																	onChange={(e) => handleChangeFrom(e)}
																	invalid={!hideError ? sessionFrom ? "" : "true" : ""}
																/>
																
																<FormFeedback>This field is required!</FormFeedback>
															</FormGroup>
															<FormGroup >
																<Label >To <span className="text-danger">*</span></Label>
																<ReactDatetime
																	value={sessionTo}
																	onChange={(e) => handleChangeTo(e)}
																	timeConstraints={{
																	minutes: { min: 30, max: 30, step: 31 },
																	}}
																	dateFormat={false}
																	className="w-100"
																	inputProps={{ placeholder: "Select End Time" }}
																	invalid={!hideError ? sessionTo ? "" : "true" : ""}
																/>
																<Input
																	type="hidden"
																	value={sessionTo} onChange={(e) => handleChangeTo(e)}
																	invalid={!hideError ? sessionFrom ? "" : "true" : ""}
																/>
																<FormFeedback>This field is required!</FormFeedback>
															</FormGroup>
															
															
															
														</Col>
													
														<Col lg="6">
															{/* {
																props.userDetails.admin == true ?    */}
																<FormGroup>
																	<Label >Select Coach <span className="text-danger">*</span></Label>
																	<Select

																		options={coachOption}
																		classNamePrefix="select"
																		placeholder="Select a Coach.."
																		onChange={handleAssignedCoach}
																		value={coaches.find(
																			(option) => option.value === assignedcoach
																		)}
																		formatOptionLabel={(v) => (
																			<div className="d-flex ">
																				{v.value ? (
																				v.image ? (
																					<img
																					className="rounded-circle  mr-1 "
																					style={{ width: "25px", height: "25px" }}
																					src={
																						"https://storage.googleapis.com/pmr-bank.firebasestorage.app/profile-picture/" +
																						v.image
																					}
																					alt={v.label}
																					/>
																				) : (
																					<div
																					className="rounded-circle profile-letter-all-users mr-1 "
																					style={{ width: "25px", height: "25px" }}
																					>
																					{v.label ? v.label.trim()[0] : ""}
																					</div>
																				)
																				) : (
																				""
																				)}

																				<span>{v.label}</span>
																			</div>
																		)}
																	/>
																</FormGroup>
																
																{/* : ""
															} */}
														
															<FormGroup>
																<Label >Comment <span className="text-danger">*</span></Label>
																<Input type="textarea" name="text" rows="6" placeholder="Write a comment here..."  value={comment} onChange={handleCommentChange} invalid={!hideError ? comment ? "" : "true" : ""}  />
																<FormFeedback>This field is required!</FormFeedback>
															</FormGroup>
														</Col>
													</Row>
													<Row>
													

														{
															typeof selectedUser.totalHoursUsed !== "undefined" 
															? 
															<>
															{
																useHoursObj.map(hObject => ({
																...hObject,
																...selectedUser.totalHoursUsed.find(myhours => myhours.category === hObject.category)
																})).map((v, i) => (
																	<Col  xl="6" className="mb-1" key={i}>
																		<Card className="card-stats mb-4 mb-xl-0 w-100">
																			<CardBody>
																				<Row>
																					<div className="col">
																						<CardTitle
																							tag="h5"
																							className="text-uppercase text-muted mb-0"
																						>
																							{v.category.replace('_',' ')}
																						</CardTitle>
																						<span className="h2 font-weight-bold mb-0">
																							{v.value}
																						</span>
																					</div>
																					<Col className="col-auto">
																						<Select 
																							
																							placeholder='Add..'
																							options={hourOptions} 
																							styles={customDropdown }  
																							onChange={(e) => handleHours({category: v.category, value: e.value})}
																							menuPortalTarget={document.body}
																							value={hourOptions.find((option) => option.value === selectedHour)}
																							
																						/>  
																					</Col>
																				</Row>
																			</CardBody>
																		</Card>
																	</Col>
															
																))
															}
																	<Col  xl="6" className="mb-1">
																		<Card className="card-stats mb-4 mb-xl-0 w-100">
																			<CardBody>
																				<Row>
																					<div className="col">
																						<CardTitle
																							tag="h5"
																							className="text-uppercase text-primary mb-0"
																						>
																						Premium Hours	
																						</CardTitle>
																						<span className="h2 font-weight-bold mb-0">
																							{selectedUser.tutorHours}
																						</span>
																					</div>
																					<Col className="col-auto">
																						<Select 
																							placeholder='Deduct..'
																							options={hourOptions} 
																							styles={customDropdown }  
																							onChange={(e) => handleHours({category: 'premium_hour', value: e.value})}
																							menuPortalTarget={document.body}
																							
																							value={hourOptions.find((option) => option.value === phour)}
																							
																						/>  
																					</Col>
																				</Row>
																			</CardBody>
																		</Card>
																	</Col>
																</>
															: 
															<>
																{
																	useHoursObj.map((v,i)=>(
																		<Col  xl="6" className="mb-1" key={i}>
																			<Card className="card-stats mb-4 mb-xl-0 w-100">
																				<CardBody>
																					<Row>
																						<div className="col">
																							<CardTitle
																								tag="h5"
																								className="text-uppercase text-muted mb-0"
																							>
																								{v.category.replace('_',' ')}
																							</CardTitle>
																							<span className="h2 font-weight-bold mb-0">
																								0
																							</span>
																						</div>
																						<Col className="col-auto">
																							<Select 
																								placeholder='Add..'
																								options={hourOptions} 
																								styles={customDropdown }  
																								onChange={(e) => handleHours({category: v.category, value: e.value})}
																								menuPortalTarget={document.body}
																								
																								value={hourOptions.find((option) => option.value === selectedHour)}
																								
																							/>  
																						</Col>
																					</Row>
																				</CardBody>
																			</Card>
																		</Col>
																	))
																}
																	<Col  xl="6" className="mb-1">
																		<Card className="card-stats mb-4 mb-xl-0 w-100">
																			<CardBody>
																				<Row>
																					<div className="col">
																						<CardTitle
																							tag="h5"
																							className="text-uppercase text-primary mb-0"
																						>
																						Premium Hours	
																						</CardTitle>
																						<span className="h2 font-weight-bold mb-0">
																							{selectedUser.tutorHours}
																						</span>
																					</div>
																					<Col className="col-auto">
																						<Select 
																							placeholder='Deduct..'
																							options={hourOptions} 
																							styles={customDropdown }  
																							onChange={(e) => handleHours({category: 'premium_hour', value: e.value})}
																							menuPortalTarget={document.body}
																							value={hourOptions.find((option) => option.value === phour)}
																							
																						/>  
																					</Col>
																				</Row>
																			</CardBody>
																		</Card>
																	</Col>
															</>
														}

													</Row>
													<Row>
														<Col lg="12"> { noValueError ? <Alert color="danger" className="mt-2">{noValueError}</Alert>  : ""}</Col>
														<Col lg="12"> { hourErrorMsg ? <Alert color="danger" className="mt-2">{hourErrorMsg}</Alert>  : ""}</Col>
													</Row>
													<Row>
														<Col xl="12" className="mt-2">
														
															{
																selectedUser.handle ? ""
																	// <StudentFreeHourLogs studenthandle={selectedUser.handle} />
																: ""
															}
																
														</Col>
														
													</Row>  
												</>
												
										:
										<Row>
											<Col lg="12" className="mt-2"><StudentFreeHourLogs studenthandle={selectedUser.handle} /></Col>
										</Row>
										}
										</TabPane>
									))
								}   
							</TabContent>           
						</Col>
					</Row> 
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={modalToggle1} >
                    Close
                    </Button>
                    
                    <Button color="primary" onClick={saveUserSession} disabled={ !assignedcoach ? true : false } >
                    Save
                    </Button>
                </ModalFooter>
            </Modal>
			<Modal
                isOpen={modal2}
                toggle={modalToggle2}
                backdrop={backdrop2}
                size="lg"
                centered
            >
                <ModalHeader toggle={modalToggle2}>
                    Manage Student's Premium Hours
                </ModalHeader>
                <ModalBody className="pt-1">
					{  
						userDetailsLoading ? 

						<div className="m-5">
							<Alert color="secondary" className="text-center">
								Fetching student.. Please wait while loading {" "}
								<Spinner size="sm" color="primary" />{" "}
							</Alert>
						</div>
					:
					<>
						<Card className="mb-3 shadow">
							<CardBody>
								<Row>
									<Col xl="6">
										{
											selectedUser ? 
												<Media className="align-items-center">
													{
														typeof selectedUser.profilePicture != "undefined" ? (
															<div className="media">
																<img 
																	src={"https://storage.googleapis.com/pmr-bank.firebasestorage.app/profile-picture/" + selectedUser.profilePicture}
																	className="mr-3" 
																	alt="..." 
																	style={{
																		width: "60px",
																		height: "60px", 
																	}}
																/>
																<div className="media-body">
																	<h5 className="mt-0">{selectedUser.name}</h5>
																	<small>{selectedUser.email}</small>
																
																</div>
															</div>
													
														) : 
														(
															<div className="media">
																<div className="rounded-circle profile-letter-all-users mr-2" 
																	style={{
																	width: "60px",
																	height: "60px",
																		fontSize: "16px"
																		}}>
																		{selectedUser.name !== undefined ? selectedUser.name.trim()[0].toUpperCase() : "1" }
																</div>
																<div className="media-body">
																	<h5 className="my-0">{selectedUser.name}</h5>
																	<small>{selectedUser.email}</small>
																
																</div>
															</div>
														)
													}
													
												</Media>
											: ""
										}
									</Col>
									<Col xl="6"  className="mt-2">
										<Card className="card-stats mb-4 mb-xl-0 w-100 shadow">
											<CardBody>
												<Row>
													<div className="col">
														<CardTitle
															tag="h5"
															className="text-uppercase mb-0"
														>
															Remaining Premium Hours
														</CardTitle>
													
													</div>
													<Col className="col-auto">
														<span className="h2 font-weight-bold mb-0">
															{selectedUser.tutorHours}
														</span>
													
													</Col>
												</Row>
											</CardBody>
										</Card>
									</Col>
								</Row>
							</CardBody>
						</Card>
						<Row>
							<Col lg="4" >
								<FormGroup>
									<Label >Date *</Label>
									<ReactDatetime
										onChange={(e) => handleChangeDate(e)}
										timeFormat={false}
										value={sessionDate} 
										className="w-100"
										inputProps={{ placeholder: "Select Date" }}
										
									/>
									<Input
										type="hidden"
										onChange={(e) => handleChangeDate(e)}
										value={sessionDate} 
										invalid={!hideError ? sessionDate ? "" : "true" : ""}
									/>
									<FormFeedback>This field is required!</FormFeedback>
								</FormGroup>
							
							</Col>
							<Col lg="4">
								<FormGroup >
									<Label >From *</Label>
									<ReactDatetime
										value={sessionFrom}
										onChange={(e) => handleChangeFrom(e)}
										timeConstraints={{
										minutes: { min: 30, max: 30, step: 31 },
										}}
										dateFormat={false}
										className="w-100"
										inputProps={{ placeholder: "Select Start Time"}}
										
									/>
									<Input
										type="hidden"
										value={sessionFrom}  
										onChange={(e) => handleChangeFrom(e)}
										invalid={!hideError ? sessionFrom ? "" : "true" : ""}
									/>
									
									<FormFeedback>This field is required!</FormFeedback>
								</FormGroup>
							</Col>
							<Col lg="4">
								<FormGroup >
									<Label >To *</Label>
										<ReactDatetime
										value={sessionTo}
										onChange={(e) => handleChangeTo(e)}
										timeConstraints={{
										minutes: { min: 30, max: 30, step: 31 },
										}}
										dateFormat={false}
										className="w-100"
										inputProps={{ placeholder: "Select End Time"}}
										invalid={!hideError ? sessionTo ? "" : "true" : ""}
									/>
									<Input
										type="hidden"
										value={sessionTo} onChange={(e) => handleChangeTo(e)}
										invalid={!hideError ? sessionFrom ? "" : "true" : ""}
									/>
									<FormFeedback>This field is required!</FormFeedback>
								</FormGroup>
							</Col> 
						</Row>
						<Row>
							<Col lg="5" className="mb-2">
								<FormGroup>
									<Label >Hours</Label>
									<Input type="number" name="premiumhours"  placeholder="Input hours.." value={phour} onChange={(e) => handleHourChange(e)} invalid={!hideError ? phour ? "" : "true" : ""}  />
									<FormFeedback>{hourErrorMsg ? hourErrorMsg : "The field is required!"}</FormFeedback>
								</FormGroup>

								{/* {
									props.userDetails.admin === true ?  */}
									<FormGroup>
										
										<Input type="hidden" invalid={!hideError ? assignedcoach ? "" : "true" : ""} />
										<Select
											
											options={coachOption}
											classNamePrefix="select"
											placeholder="Select a Coach.."
											onChange={handleAssignedCoach}
											value={coaches.find(
												(option) => option.value === assignedcoach
											)}
											formatOptionLabel={(v) => (
												<div className="d-flex ">
													{v.value ? (
													v.image ? (
														<img
														className="rounded-circle  mr-1 "
														style={{ width: "25px", height: "25px" }}
														src={
															"https://storage.googleapis.com/pmr-bank.firebasestorage.app/profile-picture/" +
															v.image
														}
														alt={v.label}
														/>
													) : (
														<div
														className="rounded-circle profile-letter-all-users mr-1 "
														style={{ width: "25px", height: "25px" }}
														>
														{v.label ? v.label.trim()[0] : ""}
														</div>
													)
													) : (
													""
													)}

													<span>{v.label}</span>
												</div>
											)}
										/>
										<FormFeedback  >This field is required!</FormFeedback>
									</FormGroup>   
									{/* : ""
								}                   */}
							</Col>
							<Col lg="7">
								<FormGroup>
									<Label >Write a comment</Label>
									<Input type="textarea" name="text" rows="5" placeholder="Type here..."  value={comment} onChange={handleCommentChange} invalid={!hideError ? comment ? "" : "true" : ""}  />
									<FormFeedback>This field is required!</FormFeedback>
								
								</FormGroup>

							</Col>
						</Row>
						<Row>
							<Col xl="12" className="mt-2">
								{
									selectedUser.handle ? 
										<StudentPremiumHourLogs studenthandle={selectedUser.handle} />
									: ""
								}
							</Col>
						</Row>  
						</>
					}
                </ModalBody>
                <ModalFooter>
					<Button  color="secondary" onClick={modalToggle2}>
						Cancel		
					</Button>
                    {/* <Button color="danger"  onClick={(e) => logPremiumHour(e, "deduct")}  >
                    Deduct Hour
                    </Button> */}
                    
                    <Button color="primary" onClick={(e) => logPremiumHour(e, "deduct")} disabled={  !assignedcoach ? true : false } >
                    Log Hour
                    </Button>
                </ModalFooter>
            </Modal>

			{/* Create Account Modal */}
			<Modal
				className="modal-dialog-centered"
				size="lg"
				isOpen={modalCreateUser}
				toggle={toggleCreateUser}
			>
				<Form onSubmit={handleCreateUserSubmit}>
					<ModalBody className="modal-body p-0">
						<Card className="bg-secondary shadow border-0">
						<CardHeader className="bg-transparent">
							<Row className="align-items-center">
							<Col xs="8">
								<h3 className="mb-0">Create Account</h3>
							</Col>
							<Col className="text-right" xs="4"></Col>
							</Row>
						</CardHeader>
						<CardBody style={{ maxHeight: "650px", overflowY: "auto" }}>
							<h6 className="heading-small text-muted mb-4">
							User Information
							</h6>
							<div className="pl-lg-4">
							<Row>
								<Col lg="6">
								<FormGroup>
									<label className="form-control-label" htmlFor="createFirstName">
									First Name <span className="text-danger">*</span>
									</label>
									<Input
									className="form-control-alternative"
									id="createFirstName"
									type="text"
									value={createUserForm.firstName}
									onChange={(e) => handleCreateUserChange("firstName", e.target.value)}
									invalid={!!createUserErrors.firstName}
									placeholder="First Name"
									/>
									{createUserErrors.firstName && <FormFeedback>{createUserErrors.firstName}</FormFeedback>}
								</FormGroup>
								</Col>
								<Col lg="6">
								<FormGroup>
									<label className="form-control-label" htmlFor="createLastName">
									Last Name <span className="text-danger">*</span>
									</label>
									<Input
									className="form-control-alternative"
									id="createLastName"
									type="text"
									value={createUserForm.lastName}
									onChange={(e) => handleCreateUserChange("lastName", e.target.value)}
									invalid={!!createUserErrors.lastName}
									placeholder="Last Name"
									/>
									{createUserErrors.lastName && <FormFeedback>{createUserErrors.lastName}</FormFeedback>}
								</FormGroup>
								</Col>
								<Col lg="6">
								<FormGroup>
									<label className="form-control-label" htmlFor="createEmail">
									Email Address <span className="text-danger">*</span>
									</label>
									<Input
									className="form-control-alternative"
									id="createEmail"
									type="email"
									value={createUserForm.email}
									onChange={(e) => handleCreateUserChange("email", e.target.value)}
									invalid={!!createUserErrors.email}
									placeholder="Email Address"
									/>
									{createUserErrors.email && <FormFeedback>{createUserErrors.email}</FormFeedback>}
								</FormGroup>
								</Col>
								<Col lg="6">
								<FormGroup>
									<label
									className="form-control-label"
									htmlFor="createYear"
									>
									Year
									</label>
									<Select
									options={yearOptions}
									value={yearOptions.find((o) => o.value === createUserForm.year) || null}
									onChange={(opt) => handleCreateUserChange("year", opt ? opt.value : "")}
									styles={customDropdownWithBorder}
									placeholder="Select Year"
									isClearable
									/>
								</FormGroup>
								</Col>
								<Col lg="6">
								<FormGroup>
									<label
									className="form-control-label"
									htmlFor="createPmrProgram"
									>
									{getSpecialty(props.activeSpecialty).name} Program
									</label>
									<Select
									options={pmrProgramOptions}
									value={pmrProgramOptions.find((o) => o.value === createUserForm.pmrProgram) || null}
									onChange={(opt) => handleCreateUserChange("pmrProgram", opt ? opt.value : "")}
									styles={customDropdownWithBorder}
									placeholder="Select Program"
									isClearable
									/>
								</FormGroup>
								</Col>
								<Col lg="6">
								<FormGroup>
									<label
									className="form-control-label"
									htmlFor="createPhoneNumber"
									>
									Phone Number (U.S.)
									</label>
									<Input
									className="form-control-alternative"
									id="createPhoneNumber"
									type="text"
									value={createUserForm.phoneNumber}
									onChange={(e) => handleCreateUserChange("phoneNumber", e.target.value)}
									placeholder="(555) 555-5555"
									/>
								</FormGroup>
								</Col>
							</Row>
							</div>

							<hr className="my-4" />

							<h6 className="heading-small text-muted mb-4">
							Password
							</h6>
							<div className="pl-lg-4">
							<Row>
								<Col lg="6">
								<FormGroup>
									<div className="d-flex justify-content-between align-items-center">
									<label className="form-control-label mb-0" htmlFor="createPassword">
									Password <span className="text-danger">*</span>
									</label>
									<a
									href="#"
									onClick={(e) => { e.preventDefault(); generatePassword(); }}
									title="Auto-generate password"
									style={{ fontSize: "0.85rem" }}
									>
									<i className="fas fa-magic mr-1"></i>Generate
									</a>
									</div>
									<Input
									className="form-control-alternative mt-2"
									id="createPassword"
									type="text"
									value={createUserForm.password}
									onChange={(e) => handleCreateUserChange("password", e.target.value)}
									invalid={!!createUserErrors.password}
									placeholder="Password"
									/>
									{createUserErrors.password && <FormFeedback>{createUserErrors.password}</FormFeedback>}
									<small className="text-muted">Min 8 chars, include letter, number, and special character</small>
								</FormGroup>
								</Col>
								<Col lg="6">
								<FormGroup>
									<label className="form-control-label" htmlFor="createConfirmPassword">
									Confirm Password <span className="text-danger">*</span>
									</label>
									<Input
									className="form-control-alternative"
									id="createConfirmPassword"
									type="text"
									value={createUserForm.confirmPassword}
									onChange={(e) => handleCreateUserChange("confirmPassword", e.target.value)}
									invalid={!!createUserErrors.confirmPassword}
									placeholder="Confirm Password"
									/>
									{createUserErrors.confirmPassword && <FormFeedback>{createUserErrors.confirmPassword}</FormFeedback>}
								</FormGroup>
								</Col>
							</Row>
							</div>

							<hr className="my-4" />

							<div className="pl-lg-4">
							<FormGroup check>
								<Label check className="form-control-label">
								<Input
									type="checkbox"
									checked={sendWelcomeEmail}
									onChange={(e) => setSendWelcomeEmail(e.target.checked)}
								/>{" "}
								Send welcome email with password to student
								</Label>
								<small className="d-block text-muted mt-1">
								The student will receive an email with their login credentials.
								</small>
							</FormGroup>
							</div>
						</CardBody>
						</Card>
					</ModalBody>
					<ModalFooter>
						<Button color="primary" type="submit">
						Create Account
						</Button>{" "}
						<Button color="secondary" onClick={toggleCreateUser}>
						Close
						</Button>
					</ModalFooter>
				</Form>
			</Modal>

		{/* Extend Subscription Modal */}
		<Modal isOpen={extendModal} toggle={() => setExtendModal(false)}>
			<ModalHeader toggle={() => setExtendModal(false)}>Extend Subscription</ModalHeader>
			<ModalBody>
				{extendUser && (
					<>
						<p className="mb-3">
							Extend subscription for <strong>{extendUser.name}</strong>
						</p>
						<FormGroup check className="mb-2">
							<Label check>
								<Input
									type="radio"
									name="extendOption"
									checked={extendOption === "boards"}
									onChange={() => setExtendOption("boards")}
								/>{" "}
								Extend to boards exam date
							</Label>
						</FormGroup>
						<FormGroup check className="mb-3">
							<Label check>
								<Input
									type="radio"
									name="extendOption"
									checked={extendOption === "custom"}
									onChange={() => setExtendOption("custom")}
								/>{" "}
								Custom date
							</Label>
						</FormGroup>
						{extendOption === "custom" && (
							<FormGroup>
								<ReactDatetime
									className="w-100"
									inputProps={{ className: "form-control", placeholder: "Select a date" }}
									timeFormat={false}
									value={customDate}
									onChange={(val) => setCustomDate(val)}
								/>
							</FormGroup>
						)}
					</>
				)}
			</ModalBody>
			<ModalFooter>
				<Button color="primary" onClick={handleExtendSubmit} disabled={extendLoading}>
					{extendLoading ? <Spinner size="sm" /> : "Submit"}
				</Button>
				<Button color="secondary" onClick={() => setExtendModal(false)}>
					Cancel
				</Button>
			</ModalFooter>
		</Modal>

		{/* Year Promotion Modal */}
		<Modal isOpen={promoModalOpen} toggle={() => setPromoModalOpen(false)} size="lg">
			<ModalHeader toggle={() => setPromoModalOpen(false)}>
				<i className="fas fa-graduation-cap mr-2"></i>
				Year Promotion
			</ModalHeader>
			<ModalBody>
				<Alert color="info">
					<strong>How it works:</strong> PGY 1→2, PGY 2→3, PGY 3→4, PGY 4→Fellow. Fellows stay as Fellow.
					<br />
					This runs automatically every July 1st. You can also trigger it manually below.
				</Alert>

				<div className="text-center mb-4">
					<Button color="warning" size="lg" onClick={handleRunPromotion} disabled={promoLoading}>
						{promoLoading ? <><Spinner size="sm" className="mr-2" /> Running...</> : <><i className="fas fa-arrow-up mr-2"></i>Run Year Promotion</>}
					</Button>
				</div>

				{promoResult && !promoResult.skipped && (
					<Alert color="success">
						<strong>Promoted {promoResult.totalPromoted} users</strong>
						<ul className="mb-0 mt-1">
							{Object.entries(promoResult.summary || {}).map(([key, count]) => (
								<li key={key}>{key}: {count} user{count !== 1 ? 's' : ''}</li>
							))}
						</ul>
					</Alert>
				)}

				<h5 className="mt-4 mb-3">Promotion Logs</h5>
				{promoLogsLoading ? (
					<div className="text-center py-3"><Spinner size="sm" color="primary" /></div>
				) : promoLogs.length === 0 ? (
					<p className="text-muted text-center">No promotion logs yet.</p>
				) : (
					<>
					<div className="table-responsive">
						<Table className="table-flush" size="sm">
							<thead className="thead-light">
								<tr>
									<th style={{ width: '30px' }}></th>
									<th>Academic Year</th>
									<th>Triggered By</th>
									<th>Date</th>
									<th>Users Promoted</th>
									<th>Summary</th>
								</tr>
							</thead>
							<tbody>
								{promoLogs
									.slice((promoLogPage - 1) * promoLogsPerPage, promoLogPage * promoLogsPerPage)
									.map((log) => {
									const isExpanded = expandedLogId === log.id;
									const promotions = log.promotions || [];
									const totalDetailPages = Math.ceil(promotions.length / promoDetailsPerPage);
									const detailPage = isExpanded ? promoDetailPage : 1;
									const pagedPromotions = promotions.slice((detailPage - 1) * promoDetailsPerPage, detailPage * promoDetailsPerPage);
									return (
									<React.Fragment key={log.id}>
									<tr
										style={{ cursor: 'pointer' }}
										onClick={() => {
											setExpandedLogId(isExpanded ? null : log.id);
											setPromoDetailPage(1);
										}}
									>
										<td className="text-center">
											<i className={`fas fa-chevron-${isExpanded ? 'down' : 'right'} text-primary`} style={{ fontSize: '0.75rem' }}></i>
										</td>
										<td><Badge color="primary">{log.academicYear}</Badge></td>
										<td><small>{log.triggeredBy}</small></td>
										<td><small>{log.executedAt ? new Date(log.executedAt).toLocaleString() : '—'}</small></td>
										<td><Badge color="success">{log.totalPromoted}</Badge></td>
										<td>
											<small>
												{Object.entries(log.summary || {}).map(([key, count]) => (
													<span key={key} className="mr-2">{key}: {count}</span>
												))}
											</small>
										</td>
									</tr>
									{isExpanded && (
									<tr>
										<td colSpan="6" style={{ backgroundColor: '#f8f9fe', padding: '12px 20px' }}>
											<Table size="sm" className="mb-0">
												<thead>
													<tr>
														<th>User</th>
														<th>Name</th>
														<th>From</th>
														<th></th>
														<th>To</th>
													</tr>
												</thead>
												<tbody>
													{pagedPromotions.map((p, i) => (
														<tr key={i}>
															<td><small className="text-muted">{p.handle}</small></td>
															<td><small>{p.name || '—'}</small></td>
															<td><Badge color="secondary">{p.from}</Badge></td>
															<td><i className="fas fa-arrow-right text-muted" style={{ fontSize: '0.7rem' }}></i></td>
															<td><Badge color="primary">{p.to}</Badge></td>
														</tr>
													))}
												</tbody>
											</Table>
											{totalDetailPages > 1 && (
												<div className="d-flex justify-content-between align-items-center mt-2">
													<small className="text-muted">
														Showing {((detailPage - 1) * promoDetailsPerPage) + 1} to {Math.min(detailPage * promoDetailsPerPage, promotions.length)} of {promotions.length} users
													</small>
													<div className="d-flex align-items-center">
														<Button color="primary" size="sm" onClick={(e) => { e.stopPropagation(); setPromoDetailPage(prev => Math.max(1, prev - 1)); }} disabled={detailPage === 1} className="mr-2">
															<i className="fas fa-chevron-left"></i>
														</Button>
														<span className="mx-2 text-nowrap small">Page {detailPage} of {totalDetailPages}</span>
														<Button color="primary" size="sm" onClick={(e) => { e.stopPropagation(); setPromoDetailPage(prev => Math.min(totalDetailPages, prev + 1)); }} disabled={detailPage >= totalDetailPages} className="ml-2">
															<i className="fas fa-chevron-right"></i>
														</Button>
													</div>
												</div>
											)}
										</td>
									</tr>
									)}
									</React.Fragment>
									);
								})}
							</tbody>
						</Table>
					</div>
					{Math.ceil(promoLogs.length / promoLogsPerPage) > 1 && (
						<div className="d-flex justify-content-between align-items-center mt-3">
							<small className="text-muted">
								Showing {((promoLogPage - 1) * promoLogsPerPage) + 1} to {Math.min(promoLogPage * promoLogsPerPage, promoLogs.length)} of {promoLogs.length} logs
							</small>
							<div className="d-flex align-items-center">
								<Button color="primary" size="sm" onClick={() => setPromoLogPage(prev => Math.max(1, prev - 1))} disabled={promoLogPage === 1} className="mr-2">
									<i className="fas fa-chevron-left"></i>
									<span className="d-none d-sm-inline ml-1">Previous</span>
								</Button>
								<span className="mx-2 text-nowrap">Page {promoLogPage} of {Math.ceil(promoLogs.length / promoLogsPerPage)}</span>
								<Button color="primary" size="sm" onClick={() => setPromoLogPage(prev => Math.min(Math.ceil(promoLogs.length / promoLogsPerPage), prev + 1))} disabled={promoLogPage >= Math.ceil(promoLogs.length / promoLogsPerPage)} className="ml-2">
									<span className="d-none d-sm-inline mr-1">Next</span>
									<i className="fas fa-chevron-right"></i>
								</Button>
							</div>
						</div>
					)}
					</>
				)}
			</ModalBody>
			<ModalFooter>
				<Button color="secondary" onClick={() => setPromoModalOpen(false)}>Close</Button>
			</ModalFooter>
		</Modal>
		</>
	);
};

const mapStateToProps = (state) => {
  return {
	userDetails : state.loginAuth.userDetails,
    fetchAllUsers: state.fetchAllUsers,
    fetchUserDetails: state.fetchUserDetails,
    updateUserDetails: state.updateUserDetails,
    updateMultiUsersReducer: state.updateMultiUsersReducer,
    fetchCoaches: state.fetchCoaches,
    fetchUniversities : state.fetchUniversities,
	fetchAppHourUsedLogs: state.fetchAppHourUsedLogs,
	fetchPremiumHourLogs: state.fetchPremiumHourLogs,
	sendEmailApplicationHourUsed: state.sendEmailApplicationHourUsed,
	adminCreateUser: state.adminCreateUser,
	activeSpecialty: state.specialty.activeSpecialty,
  };
};

export default connect(mapStateToProps)(ManageUsers);
